'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pic = require('assets/img/policy/pic1.png');

var _pic2 = _interopRequireDefault(_pic);

var _pic3 = require('assets/img/policy/pic2.png');

var _pic4 = _interopRequireDefault(_pic3);

var _pic5 = require('assets/img/policy/pic3.png');

var _pic6 = _interopRequireDefault(_pic5);

var _pic7 = require('assets/img/policy/pic4.png');

var _pic8 = _interopRequireDefault(_pic7);

var _pic9 = require('assets/img/policy/pic5.png');

var _pic10 = _interopRequireDefault(_pic9);

var _pic11 = require('assets/img/policy/pic6.png');

var _pic12 = _interopRequireDefault(_pic11);

var _pic13 = require('assets/img/policy/pic7.png');

var _pic14 = _interopRequireDefault(_pic13);

var _pic15 = require('assets/img/policy/pic8.png');

var _pic16 = _interopRequireDefault(_pic15);

var _pic17 = require('assets/img/policy/pic9.png');

var _pic18 = _interopRequireDefault(_pic17);

var _pic19 = require('assets/img/policy/pic10.png');

var _pic20 = _interopRequireDefault(_pic19);

var _pic21 = require('assets/img/policy/pic11.png');

var _pic22 = _interopRequireDefault(_pic21);

var _pic23 = require('assets/img/policy/pic12.png');

var _pic24 = _interopRequireDefault(_pic23);

var _pic25 = require('assets/img/policy/pic13.png');

var _pic26 = _interopRequireDefault(_pic25);

var _pic27 = require('assets/img/policy/pic14.png');

var _pic28 = _interopRequireDefault(_pic27);

var _pic29 = require('assets/img/policy/pic15.png');

var _pic30 = _interopRequireDefault(_pic29);

var _pic31 = require('assets/img/policy/pic16.png');

var _pic32 = _interopRequireDefault(_pic31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Activity = function (_Component) {
  (0, _inherits3.default)(Activity, _Component);

  function Activity() {
    (0, _classCallCheck3.default)(this, Activity);
    return (0, _possibleConstructorReturn3.default)(this, (Activity.__proto__ || (0, _getPrototypeOf2.default)(Activity)).apply(this, arguments));
  }

  (0, _createClass3.default)(Activity, [{
    key: 'render',
    value: function render() {
      var styles = require('./Intro.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.intro },
        _react2.default.createElement(
          'table',
          { cellSpacing: '0', cellPadding: '0', className: styles.headerTable },
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                { valign: 'middle' },
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    'C\xF4ng ty C\u1ED5 Ph\u1EA7n Lookme '
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement('br', null)
                )
              ),
              _react2.default.createElement(
                'td',
                { valign: 'middle' },
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    'C\u1ED8NG HO\xC0 X\xC3 H\u1ED8I CH\u1EE6 NGH\u0128A VI\u1EC6T NAM'
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    '\u0110\u1ED9c l\u1EADp - T\u1EF1 do - H\u1EA1nh ph\xFAc'
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement('br', null)
                )
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                { valign: 'middle' },
                _react2.default.createElement(
                  'p',
                  null,
                  'S\u1ED1: /'
                )
              ),
              _react2.default.createElement(
                'td',
                { valign: 'middle' },
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'i',
                    null,
                    'TP. HCM, ng\xE0y 17 th\xE1ng 09 n\u0103m 2019'
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          { style: { textAlign: 'center' } },
          _react2.default.createElement(
            'b',
            null,
            'QUY CH\u1EBE HO\u1EA0T \u0110\u1ED8NG'
          ),
          ' ',
          _react2.default.createElement(
            'b',
            null,
            'C\u1EE6A S\xC0N GIAO D\u1ECACH'
          )
        ),
        _react2.default.createElement(
          'p',
          { style: { textAlign: 'center' } },
          _react2.default.createElement(
            'b',
            null,
            'TH\u01AF\u01A0NG M\u1EA0I \u0110I\u1EC6N T\u1EEC '
          ),
          'WWW.LOOKME.VN'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          'Lookme.vn l\xE0 m\u1ED9t n\u1EC1n t\u1EA3ng chia s\u1EBB nh\u1EEFng \u0111\u1ECBa \u0111i\u1EC3m l\xE0m \u0111\u1EB9p uy t\xEDn, ch\u1EA5t l\u01B0\u1EE3ng, ph\xF9 h\u1EE3p v\u1EDBi nhu c\u1EA7u v\xE0 t\xFAi ti\u1EC1n c\u1EE7a m\u1ECDi ng\u01B0\u1EDDi tr\xEAn kh\u1EAFp m\u1ECDi mi\u1EC1n \u0111\u1EA5t n\u01B0\u1EDBc. Kh\xF4ng ch\u1EC9 cung c\u1EA5p to\xE0n b\u1ED9 th\xF4ng tin v\u1EC1 c\xE1c \u0111\u1ECBa \u0111i\u1EC3m v\xE0 nh\u1EEFng \u0111\xE1nh gi\xE1 t\u1EEB nh\u1EEFng ng\u01B0\u1EDDi \u0111\xE3 tr\u1EA3i nghi\u1EC7m, Lookme c\xF2n gi\xFAp b\u1EA1n chia s\u1EBB h\xECnh \u1EA3nh, \u0111\u01B0a ra nh\u1EADn x\xE9t v\xE0 t\u1EA1o nh\u1EEFng \u0111\u1ECBa \u0111i\u1EC3m y\xEAu th\xEDch cho ri\xEAng m\xECnh. Th\xF4ng qua Lookme, b\u1EA1n c\u0169ng c\xF3 th\u1EC3 k\u1EBFt n\u1ED1i v\u1EDBi b\u1EA1n b\xE8 ho\u1EB7c ng\u01B0\u1EDDi qu\u1EA3n l\xFD c\u1EE7a \u0111\u1ECBa \u0111i\u1EC3m b\u1EA1n t\xECm ki\u1EBFm m\u1ED9t c\xE1ch nhanh ch\xF3ng.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Ngo\xE0i ra Lookme.vn \u0111\xE3 \u0111\u01B0\u1EE3c li\xEAn k\u1EBFt ch\u1ECDn l\u1ECDc v\u1EDBi c\xE1c \u0111\u1ED1i t\xE1c cung c\u1EA5p d\u1ECBch v\u1EE5 v\u1EC1 l\xE0m \u0111\u1EB9p \u0111\u1EC3 ph\xE1t h\xE0nh deal/ vocher khuy\u1EBFn m\xE3i v\u1EC1 d\u1ECBch v\u1EE5 l\xE0m \u0111\u1EB9p, th\u1EA9m m\u1EF9 nh\u1EB1m cung c\u1EA5p \u0111\u1EBFn cho kh\xE1ch h\xE0ng nhi\u1EC1u \u01B0u \u0111\xE3i, khuy\u1EBFn m\xE3i \u0111\u1EC3 s\u1EED d\u1EE5ng \u0111\u01B0\u1EE3c nh\u1EEFng d\u1ECBch v\u1EE5 ch\u1EA5t l\u01B0\u1EE3ng v\u1EDBi gi\xE1 t\u1ED1t. B\u1EB1ng c\xE1ch n\xE0y, ch\xFAng t\xF4i hy v\u1ECDng s\u1EBD mang l\u1EA1i ni\u1EC1m vui cho kh\xE1ch h\xE0ng khi tham gia ho\u1EA1t \u0111\u1ED9ng tr\xEAn Lookme.vn',
          ' '
        ),
        _react2.default.createElement(
          'p',
          null,
          'Lookme.vn l\xE0 m\u1ED9t ng\xF4i nh\xE0 chung cho kh\xE1ch h\xE0ng d\u1EC5 d\xE0ng t\xECm hi\u1EC3u th\xF4ng tin v\xE0 quy\u1EBFt \u0111\u1ECBnh s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 t\u1EEB nhi\u1EC1u l\u1EF1a ch\u1ECDn phong ph\xFA, \u0111a d\u1EA1ng phong c\xE1ch t\u1EEB c\xE1c \u0111\u1ED1i t\xE1c cung c\u1EA5p d\u1ECBch v\u1EE5 ch\u0103m s\xF3c/ l\xE0m \u0111\u1EB9p hi\u1EC7n c\xF3 tr\xEAn S\xE0n.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              'Nguy\xEAn t\u1EAFc chung'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Website cung c\u1EA5p d\u1ECBch v\u1EE5 th\u01B0\u01A1ng m\u1EA1i \u0111i\u1EC7n t\u1EED Lookme.vn do C\xF4ng ty C\u1ED5 Ph\u1EA7n Lookme (C\xF4ng ty) x\xE2y d\u1EF1ng v\xE0 v\u1EADn h\xE0nh. Th\xE0nh vi\xEAn tr\xEAn website cung c\u1EA5p d\u1ECBch v\u1EE5 th\u01B0\u01A1ng m\u1EA1i \u0111i\u1EC7n t\u1EED l\xE0 c\xE1c th\u01B0\u01A1ng nh\xE2n, t\u1ED5 ch\u1EE9c, c\xE1 nh\xE2n c\xF3 ho\u1EA1t \u0111\u1ED9ng th\u01B0\u01A1ng m\u1EA1i h\u1EE3p ph\xE1p \u0111\u01B0\u1EE3c Lookme.vn ch\xEDnh th\u1EE9c c\xF4ng nh\u1EADn v\xE0 \u0111\u01B0\u1EE3c ph\xE9p s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 do Website cung c\u1EA5p d\u1ECBch v\u1EE5 th\u01B0\u01A1ng m\u1EA1i \u0111i\u1EC7n t\u1EED Lookme.vn v\xE0 c\xE1c b\xEAn li\xEAn quan cung c\u1EA5p.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Nguy\xEAn t\u1EAFc n\xE0y \xE1p d\u1EE5ng cho c\xE1c th\xE0nh vi\xEAn \u0111\u0103ng k\xFD s\u1EED d\u1EE5ng, tham gia \u0111\u0103ng th\xF4ng tin \u0111\u01B0\u1EE3c th\u1EF1c hi\u1EC7n tr\xEAn Website cung c\u1EA5p d\u1ECBch v\u1EE5 th\u01B0\u01A1ng m\u1EA1i \u0111i\u1EC7n t\u1EED Lookme.vn.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\u01B0\u01A1ng nh\xE2n, t\u1ED5 ch\u1EE9c, c\xE1 nh\xE2n tham gia giao d\u1ECBch t\u1EA1i Website cung c\u1EA5p d\u1ECBch v\u1EE5 th\u01B0\u01A1ng m\u1EA1i \u0111i\u1EC7n t\u1EED Lookme.vn t\u1EF1 do th\u1ECFa thu\u1EADn tr\xEAn c\u01A1 s\u1EDF t\xF4n tr\u1ECDng quy\u1EC1n v\xE0 l\u1EE3i \xEDch h\u1EE3p ph\xE1p c\u1EE7a c\xE1c b\xEAn tham gia ho\u1EA1t \u0111\u1ED9ng cung \u1EE9ng v\xE0 s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 kh\xF4ng tr\xE1i v\u1EDBi qui \u0111\u1ECBnh c\u1EE7a ph\xE1p lu\u1EADt.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\xF4ng tin v\u1EC1 th\u01B0\u01A1ng nh\xE2n, t\u1ED5 ch\u1EE9c, c\xE1 nh\xE2n tham gia l\xE0 th\xE0nh vi\xEAn tr\xEAn Lookme.vn ph\u1EA3i minh b\u1EA1ch v\xE0 ch\xEDnh x\xE1c.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'D\u1ECBch v\u1EE5 \u0111\u01B0\u1EE3c gi\u1EDBi thi\u1EC7u tr\xEAn Website cung c\u1EA5p d\u1ECBch v\u1EE5 th\u01B0\u01A1ng m\u1EA1i \u0111i\u1EC7n t\u1EED Lookme.vn ph\u1EA3i \u0111\xE1p \u1EE9ng \u0111\u1EA7y \u0111\u1EE7 c\xE1c quy \u0111\u1ECBnh c\u1EE7a ph\xE1p lu\u1EADt c\xF3 li\xEAn quan, kh\xF4ng thu\u1ED9c c\xE1c tr\u01B0\u1EDDng h\u1EE3p c\u1EA5m kinh doanh, c\u1EA5m qu\u1EA3ng c\xE1o theo quy \u0111\u1ECBnh c\u1EE7a ph\xE1p lu\u1EADt.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'T\u1EA5t c\u1EA3 c\xE1c n\u1ED9i dung trong Quy ch\u1EBF n\xE0y ph\u1EA3i tu\xE2n th\u1EE7 theo h\u1EC7 th\u1ED1ng ph\xE1p lu\u1EADt hi\u1EC7n h\xE0nh c\u1EE7a Vi\u1EC7t Nam. Th\xE0nh vi\xEAn khi tham gia v\xE0o Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn ph\u1EA3i t\u1EF1 t\xECm hi\u1EC3u tr\xE1ch nhi\u1EC7m ph\xE1p l\xFD c\u1EE7a m\xECnh \u0111\u1ED1i v\u1EDBi lu\u1EADt ph\xE1p hi\u1EC7n h\xE0nh c\u1EE7a Vi\u1EC7t Nam v\xE0 cam k\u1EBFt th\u1EF1c hi\u1EC7n \u0111\xFAng nh\u1EEFng n\u1ED9i dung trong Quy ch\u1EBF c\u1EE7a Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'II. Quy \u0111\u1ECBnh chung '
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'T\xEAn Mi\u1EC1n Website cung c\u1EA5p d\u1ECBch v\u1EE5 th\u01B0\u01A1ng m\u1EA1i \u0111i\u1EC7n t\u1EED: '
          ),
          'Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn do C\xF4ng ty C\u1ED5 Ph\u1EA7n Lookme ph\xE1t tri\u1EC3n v\u1EDBi t\xEAn mi\u1EC1n l\xE0: Lookme.vn (sau \u0111\xE2y g\u1ECDi t\u1EAFt l\xE0: \u201CWebsite cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn\u201D).',
          ' '
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            '\u0110\u1ECBnh ngh\u0129a chung:'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            ' Ch\u1EE7 \u0111\u1ECBa \u0111i\u1EC3m l\xE0m \u0111\u1EB9p/ \u0110\u1ED1i t\xE1c/ Nh\xE0 cung c\u1EA5p (NCC):'
          ),
          ' l\xE0 th\u01B0\u01A1ng nh\xE2n, t\u1ED5 ch\u1EE9c, c\xE1 nh\xE2n c\xF3 nhu c\u1EA7u s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 c\u1EE7a Lookme.vn bao g\u1ED3m: M\u1EDF gian h\xE0ng, \u0111\u0103ng d\u1ECBch v\u1EE5 ch\u0103m s\xF3c v\xE0 l\xE0m \u0111\u1EB9p, \u0111\u0103ng b\xE0i gi\u1EDBi thi\u1EC7u v\u1EC1 \u0111\u1ECBa \u0111i\u1EC3m kinh doanh v\xE0 c\xE1c d\u1ECBch v\u1EE5 ph\u1EE5 k\xE8m ph\u1EE5c v\u1EE5.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'Kh\xE1ch h\xE0ng: '
          ),
          'l\xE0 c\xE1 nh\xE2n c\xF3 nhu c\u1EA7u t\xECm hi\u1EC3u th\xF4ng tin v\u1EC1 c\xE1c c\xE1c d\u1ECBch v\u1EE5/ \u0111\u1ECBa \u0111i\u1EC3m l\xE0m \u0111\u1EB9p \u0111\u01B0\u1EE3c \u0111\u0103ng t\u1EA3i tr\xEAn Lookme.vn c\u1EE7a nh\xE0 cung c\u1EA5p.',
          ' '
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'Th\xE0nh vi\xEAn:'
          ),
          ' l\xE0 bao g\u1ED3m c\u1EA3 ',
          _react2.default.createElement(
            'b',
            null,
            'Nh\xE0 cung c\u1EA5p'
          ),
          ' l\u1EABn',
          ' ',
          _react2.default.createElement(
            'b',
            null,
            'Kh\xE1ch h\xE0ng'
          ),
          '.'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            ' ',
            'Th\xE0nh vi\xEAn tham gia giao d\u1ECBch tr\xEAn S\xE0n giao d\u1ECBch Lookme.vn l\xE0 th\u01B0\u01A1ng nh\xE2n, t\u1ED5 ch\u1EE9c, c\xE1 nh\xE2n c\xF3 nhu c\u1EA7u t\xECm hi\u1EC3u, s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 tr\xEAn website.'
          ),
          _react2.default.createElement(
            'li',
            null,
            'Th\xE0nh vi\xEAn ph\u1EA3i \u0111\u0103ng k\xFD k\xEA khai ban \u0111\u1EA7u c\xE1c th\xF4ng tin c\xE1 nh\xE2n c\xF3 li\xEAn quan, \u0111\u01B0\u1EE3c Ban qu\u1EA3n l\xFD s\xE0n TM\u0110T Lookme.vn ch\xEDnh th\u1EE9c c\xF4ng nh\u1EADn v\xE0 \u0111\u01B0\u1EE3c ph\xE9p s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 do Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T.',
            ' '
          ),
          _react2.default.createElement(
            'li',
            null,
            'Khi b\u1EA1n \u0111\u0103ng k\xFD l\xE0 th\xE0nh vi\xEAn c\u1EE7a Lookme.vn, th\xE0nh vi\xEAn hi\u1EC3u r\u1EB1ng:'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          '+ Th\xE0nh vi\xEAn c\xF3 th\u1EC3 t\u1EA1o m\u1ED9t t\xE0i kho\u1EA3n c\xE1 nh\xE2n c\u1EE7a m\xECnh \u0111\u1EC3 s\u1EED d\u1EE5ng.'
        ),
        _react2.default.createElement(
          'p',
          null,
          '+ Th\xE0nh vi\xEAn c\xF3 th\u1EC3 \u0111\u0103ng th\xF4ng tin gi\u1EDBi thi\u1EC7u v\u1EC1 s\u1EA3n ph\u1EA9m, d\u1ECBch v\u1EE5 m\xE0 c\xF4ng ty \u0111ang cung \u1EE9ng.'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            'S\u1EA3n ph\u1EA9m/d\u1ECBch v\u1EE5: L\xE0 d\u1ECBch v\u1EE5 ch\u0103m s\xF3c/ l\xE0m \u0111\u1EB9p c\u1EE7a c\xE1c nh\xE0 cung c\u1EA5p \u0111\xE3 k\xFD h\u1EE3p \u0111\u1ED3ng v\u1EDBi C\xF4ng ty C\u1ED5 Ph\u1EA7n Lookme v\xE0 \u0111\u01B0\u1EE3c c\u1EA5p t\xE0i kho\u1EA3n ho\u1EA1t \u0111\u1ED9ng t\u1EA1i Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn',
            _react2.default.createElement(
              'b',
              null,
              '.'
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            'N\u1ED9i dung b\u1EA3n Quy ch\u1EBF n\xE0y tu\xE2n th\u1EE7 theo c\xE1c quy \u0111\u1ECBnh hi\u1EC7n h\xE0nh c\u1EE7a Vi\u1EC7t Nam. Th\xE0nh vi\xEAn khi tham gia v\xE0o Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn ph\u1EA3i t\u1EF1 t\xECm hi\u1EC3u tr\xE1ch nhi\u1EC7m ph\xE1p l\xFD c\u1EE7a m\xECnh \u0111\u1ED1i v\u1EDBi lu\u1EADt ph\xE1p hi\u1EC7n h\xE0nh c\u1EE7a Vi\u1EC7t Nam v\xE0 cam k\u1EBFt th\u1EF1c hi\u1EC7n \u0111\xFAng nh\u1EEFng n\u1ED9i dung trong Quy ch\u1EBF c\u1EE7a S\xE0n giao d\u1ECBch Lookme.vn.'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'III. Quy tr\xECnh giao d\u1ECBch'
          )
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              _react2.default.createElement(
                'i',
                null,
                'Quy tr\xECnh d\xE0nh cho Kh\xE1ch h\xE0ng tr\xEAn website'
              )
            )
          )
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              '\u0110\u1EB7t d\u1ECBch v\u1EE5 v\u1EDBi c\xE1c \u0111\u1ECBa \u0111i\u1EC3m \u0111\u01B0\u1EE3c chia s\u1EBB tr\xEAn website:'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Ng\u01B0\u1EDDi dung khi c\xF3 nhu c\u1EA7u c\u1EA7n \u0111\u1EB7t d\u1ECBch v\u1EE5 ch\u0103m s\xF3c/ l\xE0m \u0111\u1EB9p v\xE0 c\xE1c d\u1ECBch v\u1EE5 c\u1ED9ng th\xEAm kh\xE1c tr\xEAn Lookme.vn c\u1EA7n th\u1EF1c hi\u1EC7n theo c\xE1c b\u01B0\u1EDBc sau:'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'B\u01B0\u1EDBc 1:'
          ),
          ' \u0110\u0103ng k\xFD t\xE0i kho\u1EA3n th\xE0nh vi\xEAn \u0111\u1EC3 tham gia ho\u1EA1t \u0111\u1ED9ng tr\xEAn s\xE0n Lookme.vn;',
          ' '
        ),
        _react2.default.createElement('img', { src: _pic2.default }),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'B\u01B0\u1EDBc 2:'
          ),
          ' Kh\xE1ch h\xE0ng \u0111i\u1EC1n th\xF4ng tin nhu c\u1EA7u t\xECm ki\u1EBFm d\u1ECBch v\u1EE5 c\u1EA7n \u0111\u1EB7t c\u1EE7a m\xECnh b\u1EB1ng c\xF4ng c\u1EE5 t\xECm ki\u1EBFm r\u1ED3i ch\u1ECDn t\xECm ki\u1EBFm ho\u1EB7c c\xF3 th\u1EC3 tham kh\u1EA3o c\xE1c th\xF4ng tin \u0111ang hi\u1EC3n th\u1ECB tr\xEAn trang ch\u1EE7 c\u1EE7a website;'
        ),
        _react2.default.createElement('img', { src: _pic4.default }),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'B\u01B0\u1EDBc 3:'
          ),
          ' Kh\xE1ch h\xE0ng ch\u1ECDn xem th\xF4ng tin c\u1EE7a c\xE1c nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 c\xF3 kh\u1EA3 n\u0103ng ph\xF9 h\u1ECDp v\u1EDBi nhu c\u1EA7u c\u1EA7n t\xECm c\u1EE7a m\xECnh nh\u1EA5t v\xE0 tham kh\u1EA3o v\u1EC1 gi\xE1, v\u1ECB tr\xED \u0111\u1ECBa \u0111i\u1EC3m c\u0169ng nh\u01B0 c\xE1c \u0111\xE1nh gi\xE1 c\u1EE7a ng\u01B0\u1EDDi d\xF9ng tr\u01B0\u1EDBc \u1EDF ph\u1EA7n b\xECnh lu\u1EADn th\xF4ng qua gian h\xE0ng c\u1EE7a \u0111\u1ED1i t\xE1c \u0111\u1EC3 \u0111\u01B0a ra quy\u1EBFt \u0111\u1ECBnh s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5;'
        ),
        _react2.default.createElement('img', { src: _pic6.default }),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'B\u01B0\u1EDBc 4:'
          ),
          ' D\u1EF1a tr\xEAn th\xF4ng tin tham kh\u1EA3o \u0111\u01B0\u1EE3c t\u1EEB nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5, kh\xE1ch h\xE0ng c\xF3 th\u1EC3 li\xEAn h\u1EC7 v\u1EDBi NCC qua th\xF4ng tin li\xEAn h\u1EC7 \u0111\u0103ng t\u1EA3i trong n\u1ED9i dung gi\u1EDBi thi\u1EC7u \u0111\u1ECBa \u0111i\u1EC3m \u0111\u1EC3 \u0111\u1EB7t d\u1ECBch v\u1EE5, h\u1ECFi th\xEAm th\xF4ng tin v\u1EC1 d\u1ECBch v\u1EE5 l\xE0m \u0111\u1EB9p do \u0111\u1ECBa \u0111i\u1EC3m cung c\u1EA5p ho\u1EB7c c\xF3 th\u1EC3 \u0111\u1EBFn tr\u1EF1c ti\u1EBFp \u0111\u1ECBa \u0111i\u1EC3m \u0111\u1EC3 s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5;'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'B\u01B0\u1EDBc 5:'
          ),
          ' S\u1EED d\u1EE5ng d\u1ECBch v\u1EE5, ti\u1EBFn h\xE0nh thanh to\xE1n tr\u1EF1c ti\u1EBFp cho NCC v\xE0 khi\u1EBFu n\u1EA1i (n\u1EBFu c\xF3)'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              '\u0110\u1EB7t d\u1ECBch v\u1EE5 v\u1EDBi m\u1EE5c \u201C \u01AFu \u0111\xE3i\u201D'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u0110\u1ED1i v\u1EDBi m\u1EE5c \u201C \u01AFu \u0111\xE3i\u201D tr\xEAn giao di\u1EC7n website th\xE0nh vi\xEAn ch\u1EC9 c\xF3 th\u1EC3 d\xF9ng \u0111\u1EC3 xem v\xE0 tham kh\u1EA3o c\xE1c m\u1EE9c \u01B0u \u0111\xE3i d\xE0nh cho th\xE0nh vi\u1EC7c. Vi\u1EC7c \u0111\u1EB7t mua \u01B0u \u0111\xE3i, \u0111\u1EB7t d\u1ECBch v\u1EE5 \u1EDF m\u1EE5c n\xE0y t\xEDnh n\u0103ng ch\u1EC9 \u0111\u01B0\u1EE3c th\u1EF1c hi\u1EC7n th\xF4ng qua \u1EE9ng d\u1EE5ng Lookme. Do \u0111\xF3 kh\xF4ng c\xF3 quy tr\xECnh \u0111\u1EB7t mua \u01B0u \u0111\xE3i tr\xEAn website m\xE0 website ch\u1EC9 mang t\xEDnh ch\u1EA5t xem v\xE0 tham kh\u1EA3o. Quy tr\xECnh mua \u01B0u \u0111\xE3i/ \u0111\u1EB7t d\u1ECBch v\u1EE5 s\u1EBD \u0111\u01B0\u1EE3c tr\xECnh b\xE0y r\xF5 h\u01A1n trong quy ch\u1EBF \u0111\u0103ng k\xFD \u1EE9ng d\u1EE5ng Lookme.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Giao di\u1EC7n b\xE1n voucher/deal:'
        ),
        _react2.default.createElement('img', { src: _pic8.default }),
        _react2.default.createElement('img', { src: _pic10.default }),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              _react2.default.createElement(
                'i',
                null,
                'Quy tr\xECnh d\xE0nh cho Ng\u01B0\u1EDDi b\xE1n (Ch\u1EE7 \u0110\u1ECBa \u0111i\u1EC3m l\xE0m \u0111\u1EB9p)'
              )
            )
          )
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Chu\u1EA9n b\u1ECB tin b\xE0i b\u1EB1ng ch\u1EEF v\xE0 h\xECnh \u1EA3nh:'
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'C\xE1c tin b\xE0i c\u1EA7n \u0111\u0103ng ph\u1EA3i \u0111\u01B0\u1EE3c chia th\xE0nh 2 ph\u1EA7n \u0111\u01B0\u1EE3c ph\xE2n theo \u0111\u1ECBnh d\u1EA1ng b\u1EB1ng ch\u1EEF v\xE0 h\xECnh \u1EA3nh.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'C\xE1c n\u1ED9i dung b\u1EB1ng ch\u1EEF n\xEAn \u0111\u01B0\u1EE3c \u0111\xE1nh m\xE1y s\u1EB5n tr\xEAn m\u1ED9t ch\u01B0\u01A1ng tr\xECnh so\u1EA1n th\u1EA3o v\u0103n b\u1EA3n ( MS Word, OpenOffice) theo \u0111\u1ECBnh d\u1EA1ng font Arial, c\u1EE1 ch\u1EEF 10.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'C\xE1c n\u1ED9i dung b\u1EB1ng h\xECnh \u1EA3nh \u0111\u01B0\u1EE3c \u0111\u1ECBnh d\u1EA1ng theo d\u1EA1ng \u1EA3nh jpg,bmp, ho\u1EB7c gif.'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'b',
                null,
                '\u0110\u01B0a n\u1ED9i dung l\xEAn website:'
              )
            )
          )
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              '\u0110\u0103ng \u0111\u1ECBa \u0111i\u1EC3m l\xE0m \u0111\u1EB9p'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u0110\u1EC3 \u0111\u01B0a tin b\xE0i gi\u1EDBi thi\u1EC7u v\xE0 chia s\u1EBB v\u1EC1 \u0111\u1ECBa \u0111i\u1EC3m l\xE0m \u0111\u1EB9p l\xEAn website, th\xE0nh vi\xEAn c\u1EA7n th\u1EF1c hi\u1EC7n tu\u1EA7n t\u1EF1 c\xE1c b\u01B0\u1EDBc sau:'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'B\u01B0\u1EDBc 1'
          ),
          ': V\xE0o m\u1EE5c Trang Ch\u1EE7 ch\u1ECDn \u201C ',
          _react2.default.createElement(
            'b',
            null,
            '\u0110\u0103ng k\xFD \u0111\u1ED1i t\xE1c'
          ),
          '\u201D d\u01B0\u1EDBi ch\xE2n website v\xE0 \u0111i\u1EC1n theo m\u1EABu \u0111\u1EC3 \u0111\u0103ng k\xFD th\xF4ng tin \u0111\u1ED1i t\xE1c ho\u1EB7c Li\xEAn h\u1EC7 v\u1EDBi Lookme.vn \u0111\u1EC3 \u0111\u01B0\u1EE3c t\u01B0 v\u1EA5n h\u01B0\u1EDBng d\u1EABn;'
        ),
        _react2.default.createElement('img', { src: _pic12.default }),
        _react2.default.createElement('img', { src: _pic14.default }),
        _react2.default.createElement('img', { src: _pic16.default }),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'B\u01B0\u1EDBc 2'
          ),
          ': Lookme.vn x\xE1c nh\u1EADn th\xF4ng tin \u0111\u0103ng k\xFD v\xE0 x\xE1c nh\u1EADn th\xF4ng tin sau \u0111\xF3 c\u1EA5p t\xE0i kho\u1EA3n d\xE0nh cho c\u01A1 s\u1EDF/ \u0111\u1ECBa \u0111i\u1EC3m cung c\u1EA5p d\u1ECBch v\u1EE5 l\xE0m \u0111\u1EB9p \u0111\xF3;'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'B\u01B0\u1EDBc 3:'
          ),
          ' Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 v\xE0o trang qu\u1EA3n tr\u1ECB d\xE0nh cho nh\xE0 cung c\u1EA5p v\xE0 ch\u1ECDn m\u1EE5c \u201C ',
          _react2.default.createElement(
            'b',
            null,
            'Qu\u1EA3n l\xFD c\u1EEDa h\xE0ng'
          ),
          '\u201D \u0111\u1EC3 c\u1EADp nh\u1EADt c\xE1c th\xF4ng tin li\xEAn quan \u0111\u1EBFn d\u1ECBch v\u1EE5/ \u0111\u1ECBa \u0111i\u1EC3m s\u1EBD hi\u1EC3n th\u1ECB tr\xEAn gian h\xE0ng c\u1EE7a m\xECnh theo link: https://cms.lookme.vn/login (T\xE0i kho\u1EA3n test: User: demo@lookme.vn/ Pass: demo1234);'
        ),
        _react2.default.createElement('img', { src: _pic18.default }),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            '\u0110\u1EC3 th\xEAm th\xF4ng tin \u0110\u1ECBa \u0111i\u1EC3m l\xE0m \u0111\u1EB9p ch\u1ECDn m\u1EE5c \u201C',
            ' ',
            _react2.default.createElement(
              'b',
              null,
              'Th\xEAm m\u1EDBi c\u1EEDa h\xE0ng'
            ),
            '\u201D \u0111\u1EC3 th\xEAm m\u1EDBi \u0111\u1ECBa \u0111i\u1EC3m l\xE0m \u0111\u1EB9pv\xE0 c\u1EADp nh\u1EADt c\xE1c th\xF4ng tin li\xEAn quan \u0111\u1EBFn \u0111\u1ECBa \u0111i\u1EC3m \u0111\xF3 (t\xEAn \u0111\u1ECBa \u0111i\u1EC3m, \u0111\u1ECBa ch\u1EC9, gi\u1EDBi thi\u1EC7u d\u1ECBch v\u1EE5,\u2026r\u1ED3i ch\u1ECDn \u201C ',
            _react2.default.createElement(
              'b',
              null,
              'Create'
            ),
            '\u201D \u0111\u1EC3 g\u1EEDi th\xF4ng tin l\xEAn h\u1EC7 th\u1ED1ng Lookme.vn ;'
          )
        ),
        _react2.default.createElement('img', { src: _pic20.default }),
        _react2.default.createElement('img', { src: _pic22.default }),
        _react2.default.createElement('img', { src: _pic24.default }),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            'Sau khi t\u1EA1o \u0111\u1ECBa \u0111i\u1EC3m xong v\xE0 \u0111\u01B0\u1EE3c duy\u1EC7t, nh\xE0 cung c\u1EA5p ch\u1ECDn m\u1EE5c \u201C',
            ' ',
            _react2.default.createElement(
              'b',
              null,
              'Th\xEAm d\u1ECBch v\u1EE5'
            ),
            '\u201Dt\u1EA1i \u0111\u1ECBa \u0111i\u1EC3m \u0111\u1EC3 c\u1EADp nh\u1EADt danh s\xE1ch d\u1ECBch v\u1EE5 k\xE8m b\u1EA3ng gi\xE1 t\u1EA1i \u0111\u1ECBa \u0111i\u1EC3m kinh doanh \u0111\xF3;'
          )
        ),
        _react2.default.createElement('img', { src: _pic26.default }),
        _react2.default.createElement('img', { src: _pic28.default }),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          'Ngo\xE0i ra Ch\u1EE7 \u0110\u1ECBa \u0111i\u1EC3m l\xE0m \u0111\u1EB9p c\xF2n c\xF3 th\u1EC3 th\xF4ng qua t\xE0i kho\u1EA3n qu\u1EA3n tr\u1ECB tr\xEAn Lookme.vn \u0111\u1EC3 c\u1EADp nh\u1EADt tr\u1EA1ng th\xE1i ho\u1EA1t \u0111\u1ED9ng, \u0111\xE1nh gi\xE1 c\u1EE7a kh\xE1ch h\xE0ng v\xE0 ch\u1EC9nh s\u1EEDa n\u1ED9i dung th\xF4ng tin v\u1EC1 \u0111\u1ECBa \u0111i\u1EC3m n\u1EBFu c\xF3 b\u1EA5t k\u1EF3 thay \u0111\u1ED5i n\xE0o.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'B\u1ED9 ph\u1EADn duy\u1EC7t tin c\u1EE7a S\xE0n giao d\u1ECBch Lookme.vn s\u1EBD duy\u1EC7t tin \u0111\u0103ng c\u1EE7a b\u1EA1n v\xE0 cho hi\u1EC3n th\u1ECB l\xEAn Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn . N\u1EBFu n\u1ED9i dung \u0111\u0103ng h\u1EE3p l\u1EC7 (kh\xF4ng vi ph\u1EA1m c\xE1c quy \u0111\u1ECBnh c\u1EE7a duy\u1EC7t tin c\u1EE7a s\xE0n giao d\u1ECBch Lookme.vn ), tin \u0111\u0103ng s\u1EBD \u0111\u01B0\u1EE3c k\xEDch ho\u1EA1t \u0111\u1ED3ng th\u1EDDi ban qu\u1EA3n tr\u1ECB s\u1EBD th\xF4ng b\xE1o \u0111\u1EBFn ng\u01B0\u1EDDi \u0111\u0103ng tin b\u1EB1ng email vi\u1EC7c tin \u0111\u0103ng \u0111\u01B0\u1EE3c k\xEDch ho\u1EA1t.',
          ' '
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              '\u0110\u0103ng th\xF4ng tin \u01B0u \u0111\xE3i (voucher/deal khuy\u1EBFn m\xE3i)'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'B\u01B0\u1EDBc 1'
          ),
          ': Nh\xE0 cung c\u1EA5p s\u1EBD li\xEAn h\u1EC7 \u0111\u1EBFn C\xF4ng ty qua \u0111\u1ECBa ch\u1EC9: li\xEAn h\u1EC7 v\u1EDBi c\xF4ng ty qua \u0111\u1ECBa ch\u1EC9: C\xF4ng ty C\u1ED5 Ph\u1EA7n Lookme qua s\u1ED1 \u0111i\u1EC7n tho\u1EA1i: 0933207298 v\xE0 email: hr@lookme.vn \u0111\u1EC3 \u0111\u01B0\u1EE3c t\u01B0 v\u1EA5n k\xFD k\u1EBFt h\u1EE3p \u0111\u1ED3ng cung c\u1EA5p d\u1ECBch v\u1EE5 khuy\u1EBFn m\u1EA1i tr\u1EF1c tuy\u1EBFn'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'B\u01B0\u1EDBc 2'
          ),
          ': Lookme.vn x\xE1c nh\u1EADn th\xF4ng tin \u0111\u0103ng k\xFD v\xE0 li\xEAn h\u1EC7 t\u01B0 v\u1EA5n c\u0169ng nh\u01B0 giao k\u1EBFt h\u1EE3p \u0111\u1ED3ng h\u1EE3p t\xE1c d\u1ECBch v\u1EE5 v\u1EDBi Nh\xE0 cung c\u1EA5p;'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'B\u01B0\u1EDBc 3:'
          ),
          ' Sau khi k\xFD H\u1EE3p \u0111\u1ED3ng h\u1EE3p t\xE1c d\u1ECBch v\u1EE5 v\u1EDBi Lookme.vn th\xEC \u0111\u1ED1i t\xE1c c\u1EA7n cung c\u1EA5p c\xE1c th\xF4ng tin d\u1ECBch v\u1EE5 c\u1EA7n gi\u1EA3m gi\xE1, m\u1EE9c \u01B0u \u0111\xE3i, th\u1EDDi gian v\xE0 \u0111\u1ECBa \u0111i\u1EC3m \u0111\u01B0\u1EE3c \u01B0u \u0111\xE3i sau \u0111\xF3 b\u1ED9 ph\u1EADn bi\xEAn t\u1EADp c\u1EE7a Lookme.vn s\u1EBD ho\xE0n ch\u1EC9nh n\u1ED9i dung voucher/deal khuy\u1EBFn m\xE3i theo quy chu\u1EA9n c\u1EE7a website tr\u01B0\u1EDBc khi cho hi\u1EC3n th\u1ECB n\u1ED9i dung c\xF4ng khai tr\xEAn website;'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'B\u01B0\u1EDBc 4:'
          ),
          ' D\u1EF1a v\xE0o h\u1EE3p \u0111\u1ED3ng d\u1ECBch v\u1EE5, C\xF4ng ty s\u1EBD ph\xE1t h\xE0nh phi\u1EBFu mua h\xE0ng/phi\u1EBFu s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 c\u1EE7a Nh\xE0 cung c\u1EA5p d\u01B0\u1EDBi d\u1EA1ng m\xE3 \u0111i\u1EC7n t\u1EED (QR code) \u0111\u1EC3 Kh\xE1ch H\xE0ng \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 c\u1EE7a Nh\xE0 cung c\u1EA5p \u0111\xF3 v\u1EDBi gi\xE1 \u01B0u \u0111\xE3i ho\u1EB7c h\u01B0\u1EDFng nh\u1EEFng l\u1EE3i \xEDch kh\xE1c t\u1EA1i \u0111\u1ECBa \u0111i\u1EC3m \u0111\u01B0\u1EE3c c\xF4ng b\u1ED1 c\u1EE7a Nh\xE0 cung c\u1EA5p .'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Giao di\u1EC7n b\xE1n voucher/deal:'
        ),
        _react2.default.createElement('img', { src: _pic30.default }),
        _react2.default.createElement('img', { src: _pic32.default }),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          'B\u01B0\u1EDBc 5: NCC cung c\u1EA5p s\u1EA3n ph\u1EA9m ho\u1EB7c d\u1ECBch v\u1EE5 cho kh\xE1ch h\xE0ng theo \u0111\xFAng \u0111i\u1EC1u ki\u1EC7n quy \u0111\u1ECBnh tr\xEAn Lookme.vn .'
        ),
        _react2.default.createElement(
          'p',
          null,
          'B\u01B0\u1EDBc 6: NCC th\u1EF1c hi\u1EC7n giao h\xE0ng, \u0111\u1ED5i tr\u1EA3, b\u1EA3o h\xE0nh cho kh\xE1ch h\xE0ng.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'B\u01B0\u1EDBc 7: NCC ph\u1ED1i h\u1EE3p v \u1EDB i C\xF4ng ty Lookme \u0111\u1EC3 gi\u1EA3i quy\u1EBFt c\xE1c v\u1EA5n \u0111\u1EC1 tranh ch\u1EA5p li\xEAn quan \u0111\u1EBFn s\u1EA3n ph\u1EA9m/d\u1ECBch v\u1EE5 m\xE0 NCC b\xE1n cho kh\xE1ch h\xE0ng (n\u1EBFu c\xF3).'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              _react2.default.createElement(
                'i',
                null,
                'Ch\xEDnh s\xE1ch giao nh\u1EADn'
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'V\xEC t\xEDnh ch\u1EA5t c\u1EE7a website l\xE0 website gi\u1EDBi thi\u1EC7u \u0111\u1ECBa \u0111i\u1EC3m v\u1EC1 c\xE1c d\u1ECBch v\u1EE5 l\xE0m \u0111\u1EB9p n\xEAn Lookme.vn kh\xF4ng cung c\u1EA5p hay h\u1ED7 tr\u1EE3 v\u1EC1 quy tr\xECnh v\u1EADn chuy\u1EC3n s\u1EA3n ph\u1EA9m nh\u01B0 c\xE1c Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T kh\xE1c.',
          ' '
        ),
        _react2.default.createElement(
          'p',
          null,
          'Hi\u1EC7n website ch\u01B0a t\xEDch h\u1EE3p t\xEDnh n\u0103ng \u0111\u1EB7t l\u1ECBch tr\u1EF1c tuy\u1EBFn n\xEAn n\u1EBFu kh\xE1ch h\xE0ng c\xF3 nhu c\u1EA7u \u0111\u1EB7t d\u1ECBch v\u1EE5 t\u1EA1i c\xE1c \u0110\u1ECBa \u0111i\u1EC3m l\xE0m \u0111\u1EB9p \u0111\u01B0\u1EE3c chia s\u1EBB tr\xEAn website Lookme.vn v\xE0 ch\u1EE7 \u0111\u1ED9ng li\xEAn h\u1EC7 ri\xEAng \u0111\u1EC3 \u0111\u1EB7t d\u1ECBch v\u1EE5 v\u1EDBi c\xE1c \u0111\u1ECBa \u0111i\u1EC3m \u0111\xF3 theo th\xF4ng tin li\xEAn h\u1EC7 hi\u1EC3n th\u1ECB tr\xEAn Lookme th\xEC v\u1EDBi h\xECnh th\u1EE9c n\xE0y Lookme.vn kh\xF4ng ph\u1EA3i l\xE0 nh\xE0 cung c\u1EA5p c\u0169ng kh\xF4ng tham gia v\xE0o qu\xE1 tr\xECnh ki\u1EC3m duy\u1EC7t n\u1ED9i dung v\xE0 ch\u1EA5t l\u01B0\u1EE3ng d\u1ECBch v\u1EE5 do \u0111\xF3 vi\u1EC7c s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 l\xE0 th\u1ECFa thu\u1EADn ri\xEAng gi\u1EEFa kh\xE1ch h\xE0ng v\xE0 c\u01A1 s\u1EDF l\xE0m \u0111\u1EB9p \u0111\xF3, m\u1ECDi tr\xE1ch nhi\u1EC7m thu\u1ED9c n\u1EBFu c\xF3 v\u1EA5n \u0111\u1EC1 ph\xE1t sinh th\xEC hai b\xEAn ch\u1EE7 \u0111\u1ED9ng th\u1ECFa thu\u1EADn x\u1EED l\xFD.',
          ' '
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u0110\u1ED1i v\u1EDBi h\xECnh th\u1EE9c mua deal/voucher khuy\u1EBFn m\xE3i th\xEC sau khi ng\u01B0\u1EDDi d\xF9ng ch\u1ECDn \u01B0u \u0111\xE3i v\xE0 thanh to\xE1n 100% gi\xE1 tr\u1ECB \u0111\u01A1n h\xE0ng h\u1EC7 th\u1ED1ng s\u1EBD t\u1EF1 \u0111\u1ED9ng g\u1EEDi M\xE3 E-voucher/ m\xE3 khuy\u1EBFn m\xE3i qua c\xE1c h\xECnh th\u1EE9c nh\u01B0 email/SMS (m\xE3 QR code) \u0111\u1EC3 kh\xE1ch h\xE0ng l\u01B0u tr\u1EEF v\xE0 s\u1EED d\u1EE5ng. \u0110\u1ED1i v\u1EDBi h\xECnh th\u1EE9c d\xF9ng voucher/deal khuy\u1EBFn m\xE3i th\xEC kh\xE1ch h\xE0ng tr\u1EF1c ti\u1EBFp li\xEAn h\u1EC7 \u0111\u1EBFn Nh\xE0 cung c\u1EA5p (NCC) d\u1ECBch v\u1EE5 \u0111\u1EC3 \u0111\u01B0\u1EE3c h\u1ED7 tr\u1EE3 vi\u1EC7c s\u1EED d\u1EE5ng voucher v\xE0 s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            '*L\u01B0u \xFD'
          ),
          ': Tr\u01B0\u1EDDng h\u1EE3p kh\xE1ch h\xE0ng thay \u0111\u1ED5i s\u1ED1 \u0111i\u1EC7n tho\u1EA1i \u0111\u1EB7t h\xE0ng/email t\xE0i kho\u1EA3n sau khi thanh to\xE1n th\xE0nh c\xF4ng & m\xE3 E-voucher \u0111\xE3 \u0111\u01B0\u1EE3c g\u1EEDi \u0111i Lookme.vn s\u1EBD kh\xF4ng ch\u1ECBu tr\xE1ch nhi\u1EC7m trong tr\u01B0\u1EDDng h\u1EE3p m\u1EA5t m\xE1t th\xF4ng tin ',
          _react2.default.createElement(
            'b',
            null,
            'E-voucher'
          ),
          '. Kh\xE1ch h\xE0ng khi c\xF3 nhu c\u1EA7u thay \u0111\u1ED5i s\u1ED1 \u0111i\u1EC7n tho\u1EA1i \u0111\u1EB7t h\xE0ng/email t\xE0i kho\u1EA3n vui l\xF2ng li\xEAn h\u1EC7 ph\xF2ng CSKH qua Hotline: 0933207298 \u0111\u1EC3 \u0111\u01B0\u1EE3c t\u01B0 v\u1EA5p & c\u1EADp nh\u1EADt th\xF4ng tin k\u1ECBp th\u1EDDi.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              _react2.default.createElement(
                'i',
                null,
                'Ch\xEDnh s\xE1ch b\u1EA3o h\xE0nh'
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Lookme.vn c\xF3 tr\xE1ch nhi\u1EC7m h\u1ED7 tr\u1EE3 c\xE1c \u0111\u1ED1i t\xE1c, ch\u1EE7 \u0110\u1ECBa \u0111i\u1EC3m l\xE0m \u0111\u1EB9p tham gia \u0111\u0103ng t\u1EA3i c\xE1c h\xECnh \u1EA3nh, d\u1ECBch v\u1EE5 tr\xEAn Lookme.vn . Khi \u0111\u1ED1i t\xE1c, nh\xE0 cung c\u1EA5p g\u1EB7p b\u1EA5t k\u1EF3 s\u1EF1 c\u1ED1 n\xE0o li\xEAn quan \u0111\u1EBFn vi\u1EC7c s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 tr\xEAn, ch\xFAng t\xF4i s\u1EBD ti\u1EBFn h\xE0nh h\u1ED7 tr\u1EE3, b\u1EA3o h\xE0nh cho d\u1ECBch v\u1EE5 \u0111\xF3.'
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u0110\u1ED1i v\u1EDBi kh\xE1ch h\xE0ng \u0111\u0103ng k\xFD gi\u1EDBi thi\u1EC7u \u0111\u1ECBa \u0111i\u1EC3m l\xE0m \u0111\u1EB9p tr\xEAn Lookme.vn th\xEC tr\xE1ch nhi\u1EC7m \u0111\u1EA3m b\u1EA3o ch\u1EA5t l\u01B0\u1EE3ng d\u1ECBch v\u1EE5 (c\u01A1 s\u1EDF v\u1EADt ch\u1EA5t ph\u1EE5c v\u1EE5 cho d\u1ECBch v\u1EE5) thu\u1ED9c v\u1EC1 \u0111\u1ED1i nh\xE0 cung c\u1EA5p \u0111\xF3. Tuy nhi\xEAn, C\xF4ng ty y\xEAu c\u1EA7u \u0111\u1ED1i t\xE1c ph\u1EA3i cung d\u1ECBch v\u1EE5 \u0111\xFAng n\u1ED9i dung \u0111\xE3 m\xF4 t\u1EA3 tr\xEAn website. Trong tr\u01B0\u1EDDng h\u1EE3p kh\xE1ch h\xE0ng kh\xF4ng \u0111\u01B0\u1EE3c ph\u1EE5c v\u1EE5 \u0111\xFAng v\u1EDBi ch\u1EA5t l\u01B0\u1EE3ng v\xE0 n\u1ED9i dung \u0111\xE3 m\xF4 t\u1EA3 khi mua vocher/deal khuy\u1EBFn m\u1EA1i t\u1EA1i Lookme.vn , kh\xE1ch h\xE0ng c\xF3 th\u1EC3 li\xEAn h\u1EC7 \u0111\u1EBFn Lookme.vn \u0111\u1EC3 ph\u1EA3n \xE1nh v\u1EC1 t\xECnh tr\u1EA1ng tr\xEAn \u0111\u1EC3 \u0111\u01B0\u1EE3c t\u01B0 v\u1EA5n v\xE0 h\u01B0\u1EDBng d\u1EABn nh\u1EEFng th\xF4ng tin c\u1EA7n thi\u1EBFt \u0111\u1EC3 \u0111\u1EA3m b\u1EA3o quy\u1EC1n l\u1EE3i c\u1EE7a m\xECnh.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              _react2.default.createElement(
                'i',
                null,
                'Ch\xEDnh s\xE1ch h\u1EE7y v\xE0 ho\xE0n tr\u1EA3 h\xE0ng'
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Do website ch\u01B0a h\u1ED7 tr\u1EE3 t\xEDnh n\u0103ng \u0111\u1EB7t l\u1ECBch tr\u1EF1c tuy\u1EBFn n\xEAn kh\xE1ch h\xE0ng t\u1EF1 \u0111\u1EB7t d\u1ECBch v\u1EE5 sau khi tham kh\u1EA3o th\xF4ng tin \u0111\u1ECBa \u0111i\u1EC3m th\xF4ng qua Lookme.vn th\xEC ch\xEDnh s\xE1ch \u0111\u1ED5i tr\u1EA3/ ho\xE0n ti\u1EC1n c\u1EE7a d\u1ECBch v\u1EE5 \u0111\xF3 ho\xE0n to\xE0n do ng\u01B0\u1EDDi cung c\u1EA5p d\u1ECBch v\u1EE5 quy \u0111\u1ECBnh ho\u1EB7c t\xF9y theo th\u1ECFa thu\u1EADn gi\u1EEFa kh\xE1ch h\xE0ng v\xE0 nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 tr\u01B0\u1EDBc khi giao k\u1EBFt.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Lookme.vn khuy\u1EBFn c\xE1o kh\xE1ch h\xE0ng n\xEAn t\xECm hi\u1EC3u ho\u1EB7c trao \u0111\u1ED5i/ th\u1ECFa thu\u1EADn tr\u01B0\u1EDBc v\u1EDBi \u0111\u1ECBa \u0111i\u1EC3m cung c\u1EA5p d\u1ECBch v\u1EE5 l\xE0m \u0111\u1EB9p \u0111\u1EC3 \u0111\u1EA3m b\u1EA3o quy\u1EC1n l\u1EE3i th\u1ECFa \u0111\xE1ng v\xEC trong c\xE1c tr\u01B0\u1EDDng h\u1EE3p n\xE0y Lookme.vn kh\xF4ng tham gia qu\xE1 v\xE0o tr\xECnh cung \u1EE9ng hay cam k\u1EBFt v\u1EC1 ch\u1EA5t l\u01B0\u1EE3ng d\u1ECBch v\u1EE5 t\u1EEB c\xE1c \u0111i\u1EC3m \u0111\xF3 \u0111\xF3 do \u0111\xF3 ng\u01B0\u1EDDi mua ph\u1EA3i t\u1EF1 ch\u1ECBu tr\xE1ch nhi\u1EC7m gi\u1EA3i quy\u1EBFt v\u1EDBi b\xEAn cung c\u1EA5p n\u1EBFu c\xF3 ph\xE1t sinh tranh ch\u1EA5p.'
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u0110\u1ED1i v\u1EDBi d\u1ECBch v\u1EE5 voucher/ deal khuy\u1EBFn m\xE3i do Lookme.vn ph\xE1t h\xE0nh \u1EDF m\u1EE5c \u01B0u \u0111\xE3i tr\xEAn website c\u1EE7a m\xECnh th\xEC nh\u1EB1m cam k\u1EBFt v\u1EC1 ch\u1EA5t l\u01B0\u1EE3ng d\u1ECBch v\u1EE5 h\u1EADu m\xE3i c\u1EE7a Lookme.vn \u0111\u1ED3ng th\u1EDDi b\u1EA3o v\u1EC7 quy\u1EC1n l\u1EE3i cao nh\u1EA5t c\u1EE7a kh\xE1ch h\xE0ng, ngo\u1EA1i tr\u1EEB nh\u1EEFng deal c\xF3 \u0111i\u1EC1u ki\u1EC7n \u0111\u1ED5i tr\u1EA3 ri\xEAng, Lookme.vn s\u1EB5n l\xF2ng ho\xE0n l\u1EA1i 100% gi\xE1 b\xE1n cho qu\xFD kh\xE1ch n\u1EBFu kh\xF4ng th\u1EC3 s\u1EED d\u1EE5ng \u0111\u01B0\u1EE3c voucher/s\u1EA3n ph\u1EA7m do l\u1ED7i c\u1EE7a Lookme.vn ho\u1EB7c do l\u1ED7i c\u1EE7a nh\xE0 cung c\u1EA5p s\u1EA3n ph\u1EA9m/d\u1ECBch v\u1EE5, chi ti\u1EBFt nh\u01B0 sau:',
          ' '
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'Quy \u0111\u1ECBnh \u0111\u1ED5i tr\u1EA3/ho\xE0n ti\u1EC1n \u0111\u1ED1i v\u1EDBi voucher gi\u1EA5y v\xE0 e-voucher'
          ),
          ' '
        ),
        _react2.default.createElement(
          'p',
          null,
          'Lookme.vn ho\xE0n l\u1EA1i 100% gi\xE1 tr\u1ECB voucher cho c\xE1c l\u1ED7i ph\xE1t sinh t\u1EEB Lookme.vn ho\u1EB7c nh\xE0 cung c\u1EA5p, n\u1EBFu x\u1EA3y ra c\xE1c tr\u01B0\u1EDDng h\u1EE3p sau:'
        ),
        _react2.default.createElement(
          'p',
          null,
          '- Th\xF4ng tin tr\xEAn voucher kh\xF4ng \u0111\xFAng.'
        ),
        _react2.default.createElement(
          'p',
          null,
          '- C\xF3 s\u1EF1 \u0111i\u1EC1u ch\u1EC9nh v\u1EC1 \u0111i\u1EC1u ki\u1EC7n deal sau khi Qu\xFD kh\xE1ch mua.'
        ),
        _react2.default.createElement(
          'p',
          null,
          '- \u0110\u1ED1i t\xE1c ph\u1EE5c v\u1EE5 kh\xF4ng \u0111\xFAng nh\u01B0 cam k\u1EBFt trong \u0111i\u1EC1u ki\u1EC7n deal.'
        ),
        _react2.default.createElement(
          'p',
          null,
          '- \u0110\u1ED1i t\xE1c kh\xF4ng th\u1EC3 ti\u1EBFp t\u1EE5c ph\u1EE5c v\u1EE5 \u0111\u01B0\u1EE3c.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            '\u0110\u1ED1i v\u1EDBi c\xE1c tr\u01B0\u1EDDng h\u1EE3p kh\xE1ch h\xE0ng mu\u1ED1n ho\xE0n tr\u1EA3 voucher v\xEC l\xFD do c\xE1 nh\xE2n'
          ),
          ', ngo\xE0i m\u1ED9t s\u1ED1 lo\u1EA1i voucher/e-voucher \u0111\u1EB7c bi\u1EC7t kh\xF4ng \xE1p d\u1EE5ng ch\xEDnh s\xE1ch ho\xE0n tr\u1EA3 \u0111\u01B0\u1EE3c ghi r\xF5 trong ph\u1EA7n \u0111i\u1EC1u ki\u1EC7n deal, Lookme.vn s\u1EBD thu ph\xED d\u1ECBch v\u1EE5 \u0111\xE3 ph\u1EE5c v\u1EE5 l\xE0 20% gi\xE1 b\xE1n c\u1EE7a voucher/e-voucher (t\u1ED1i thi\u1EC3u l\xE0 30.000\u0111/voucher ho\u1EB7c e-voucher). S\u1ED1 ti\u1EC1n c\xF2n l\u1EA1i c\u1EE7a voucher/e-voucher sau khi tr\u1EEB ph\xED d\u1ECBch v\u1EE5 c\u1EE7a Lookme.vn s\u1EBD \u0111\u01B0\u1EE3c ho\xE0n v\xE0o t\xE0i kho\u1EA3n Kh\xE1ch h\xE0ng tr\xEAn Lookme.vn d\xF9ng cho nh\u1EEFng l\u1EA7n mua h\xE0ng sau c\u1EE7a Qu\xFD kh\xE1ch.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            '\u0110\u1ED1i v\u1EDBi c\xE1c e-voucher \u0111\xE3 b\u1ECB th\u1EA5t l\u1EA1c ho\u1EB7c m\u1EA5t m\xE1t'
          ),
          ', Lookme.vn c\xF3 th\u1EC3 h\u1ED7 tr\u1EE3 c\u1EA5p m\u1EDBi v\u1EDBi \u0111i\u1EC1u ki\u1EC7n e-voucher ch\u01B0a \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng t\u1EA1i \u0111\u1ED1i t\xE1c v\xE0 ng\u01B0\u1EDDi y\xEAu c\u1EA7u c\u1EA5p m\u1EDBi l\xE0 ng\u01B0\u1EDDi s\u1EDF h\u1EEFu \u0110\u01A1n h\xE0ng \u0111\xE3 \u0111\u1EB7t mua \u0111\u01B0\u1EE3c ghi nh\u1EADn trong h\u1EC7 th\u1ED1ng c\u1EE7a Lookme.vn.',
          ' '
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              _react2.default.createElement(
                'i',
                null,
                'Quy tr\xECnh gi\u1EA3i quy\u1EBFt tranh ch\u1EA5p, khi\u1EBFu n\u1EA1i'
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Lookme.vn v\xE0 \u0111\u1ED1i t\xE1c cung c\u1EA5p d\u1ECBch v\u1EE5 c\xF3 tr\xE1ch nhi\u1EC7m ti\u1EBFp nh\u1EADn v\xE0 x\u1EED l\xFD khi\u1EBFu n\u1EA1i c\u1EE7a Th\xE0nh vi\xEAn li\xEAn quan \u0111\u1EBFn giao d\u1ECBch t\u1EA1i website Lookme.vn .'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\xE0nh vi\xEAn c\xF3 quy\u1EC1n g\u1EEDi khi\u1EBFu n\u1EA1i v\u1EC1 vi\u1EC7c ch\u1EA5t l\u01B0\u1EE3ng d\u1ECBch v\u1EE5 kh\xF4ng \u0111\xFAng v\u1EDBi m\xF4 t\u1EA3, th\xF4ng tin thanh to\xE1n b\u1ECB ti\u1EBFt l\u1ED9 g\xE2y thi\u1EC7t h\u1EA1i cho m\xECnh \u0111\u1EBFn Ban qu\u1EA3n tr\u1ECB c\u1EE7a SGD TM\u0110T Lookme.vn . Khi ti\u1EBFp nh\u1EADn nh\u1EEFng ph\u1EA3n h\u1ED3i n\xE0y, Lookme.vn s\u1EBD x\xE1c nh\u1EADn l\u1EA1i th\xF4ng tin, tr\u01B0\u1EDDng h\u1EE3p \u0111\xFAng nh\u01B0 ph\u1EA3n \xE1nh c\u1EE7a Th\xE0nh vi\xEAn t\xF9y theo m\u1EE9c \u0111\u1ED9, Lookme.vn s\u1EBD c\xF3 nh\u1EEFng bi\u1EC7n ph\xE1p x\u1EED l\xFD k\u1ECBp th\u1EDDi.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'C\xE1c b\u01B0\u1EDBc gi\u1EA3i quy\u1EBFt tranh ch\u1EA5p, khi\u1EBFu n\u1EA1i:'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            _react2.default.createElement(
              'i',
              null,
              'B\u01B0\u1EDBc 1: Ti\u1EBFp nh\u1EADn khi\u1EBFu n\u1EA1i'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\xE0nh vi\xEAn c\xF3 th\u1EC3 g\u1EEDi \xFD ki\u1EBFn \u0111\xF3ng g\xF3p ho\u1EB7c \u0111\u01A1n khi\u1EBFu n\u1EA1i b\u1EB1ng c\xE1c h\xECnh th\u1EE9c sau:'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            'G\u1EEDi th\u01B0 qua \u0111\u01B0\u1EDDng b\u01B0u \u0111i\u1EC7n v\u1EC1 \u0111\u1ECBa ch\u1EC9 tr\u1EE5 s\u1EDF ch\xEDnh c\u1EE7a Lookme.vn (Trong n\u1ED9i dung th\u01B0 ghi r\xF5 nh\u1EEFng v\u1EA5n \u0111\u1EC1 Th\xE0nh vi\xEAn c\u1EA7n khi\u1EBFu n\u1EA1i v\xE0 m\u1ED9t s\u1ED1 th\xF4ng tin t\xE0i li\u1EC7u li\xEAn quan \u0111\u1EC3 h\u1ED7 tr\u1EE3 cho vi\u1EC7c x\u1EED l\xFD v\xE0 gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i).'
          ),
          _react2.default.createElement(
            'li',
            null,
            'Ng\u01B0\u1EDDi mua g\u1EEDi khi\u1EBFu n\u1EA1i t\u1EA1i \u0111\u1ECBa ch\u1EC9: '
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'C\xF4ng ty C\u1ED5 Ph\u1EA7n Lookme'
        ),
        _react2.default.createElement(
          'p',
          null,
          'V\u0103n ph\xF2ng giao d\u1ECBch: 481/14 \u0110\u01B0\u1EDDng s\u1ED1 10, Ph\u01B0\u1EDDng 8, Qu\u1EADn G\xF2 V\u1EA5p, Th\xE0nh ph\u1ED1 H\u1ED3 Ch\xED Minh'
        ),
        _react2.default.createElement(
          'p',
          null,
          'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i: 0903 933 880 - Email: hr@lookme.vn '
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            _react2.default.createElement(
              'i',
              null,
              'B\u01B0\u1EDBc 2: Ph\xE2n t\xEDch, \u0111\xE1nh gi\xE1'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Trong v\xF2ng 24 gi\u1EDD (kh\xF4ng k\u1EC3 ng\xE0y Th\u1EE9 b\u1EA3y, Ch\u1EE7 nh\u1EADt, L\u1EC5, T\u1EBFt) k\u1EC3 t\u1EEB ng\xE0y ti\u1EBFp nh\u1EADn \u0111\u01A1n khi\u1EBFu n\u1EA1i, Lookme.vn s\u1EBD ti\u1EBFn h\xE0nh \u0111i\u1EC1u tra, x\xE1c minh, ph\xE2n t\xEDch v\xE0 \u0111\xE1nh gi\xE1 \u0111\u01A1n khi\u1EBFu n\u1EA1i c\u1EE7a Th\xE0nh vi\xEAn b\u1EB1ng c\xE1ch x\xE1c th\u1EF1c l\u1EA1i th\xF4ng tin v\u1EDBi \u0111\u1ED1i t\xE1c v\u1EC1 tr\u01B0\u1EDDng h\u1EE3p \u0111\xF3 c\u0169ng nh\u01B0 n\u1EBFu th\u1EA5y t\xEDnh ch\u1EA5t nghi\xEAm tr\u1ECDng, ch\xFAng t\xF4i s\u1EBD y\xEAu c\u1EA7u c\xE1c b\xEAn cung c\u1EA5p them b\u1EB1ng ch\u1EE9ng, ch\u1EE9ng t\u1EEB ch\u1EE9ng minh cho v\u1EE5 vi\u1EC7c.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            _react2.default.createElement(
              'i',
              null,
              'B\u01B0\u1EDBc 3: T\u1ED5ng h\u1EE3p th\xF4ng tin v\xE0 gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Sau khi x\xE1c minh r\xF5 v\u1EA5n \u0111\u1EC1 khi\u1EBFu n\u1EA1i, Lookme.vn s\u1EBD t\u1ED5ng h\u1EE3p th\xF4ng tin v\xE0 c\u0103n c\u1EE9 theo quy \u0111\u1ECBnh c\u1EE7a Lookme.vn \u0111\u1EC3 x\u1EED l\xFD v\xE0 gi\u1EA3i \u0111\xE1p khi\u1EBFu n\u1EA1i c\u1EE7a kh\xE1ch h\xE0ng.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            _react2.default.createElement(
              'i',
              null,
              'B\u01B0\u1EDBc 4: Tr\u1EA3 l\u1EDDi kh\xE1ch h\xE0ng'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Trong v\xF2ng 24 gi\u1EDD l\xE0m vi\u1EC7c k\u1EC3 t\u1EEB khi nh\u1EADn \u0111\u01B0\u1EE3c khi\u1EBFu n\u1EA1i, Lookme.vn s\u1EBD c\xF3 ph\u1EA3n h\u1ED3i cho Th\xE0nh vi\xEAn th\xF4ng qua nh\u1EEFng ph\u01B0\u01A1ng ti\u1EC7n kh\xE1c nh\u01B0 email, \u0111i\u1EC7n tho\u1EA1i. N\u1EBFu khi\u1EBFu n\u1EA1i c\xF3 t\xEDnh ch\u1EA5t ph\u1EE9c t\u1EA1p v\xE0 c\u1EA7n th\xEAm th\u1EDDi gian \u0111\u1EC3 gi\u1EA3i quy\u1EBFt v\xE0 tr\u1EA3 l\u1EDDi cho Th\xE0nh vi\xEAn m\u1ED9t c\xE1ch r\xF5 r\xE0ng, Lookme.vn s\u1EBD tr\u1EF1c ti\u1EBFp li\xEAn h\u1EC7 v\u1EDBi kh\xE1ch h\xE0ng \u0111\u1EC3 gia h\u1EA1n th\u1EDDi gian tr\u1EA3 l\u1EDDi.',
          ' '
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            _react2.default.createElement(
              'i',
              null,
              'B\u01B0\u1EDBc 5: K\u1EBFt th\xFAc'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Lookme.vn t\xF4n tr\u1ECDng v\xE0 nghi\xEAm t\xFAc th\u1EF1c hi\u1EC7n c\xE1c quy \u0111\u1ECBnh c\u1EE7a ph\xE1p lu\u1EADt v\u1EC1 b\u1EA3o v\u1EC7 quy\u1EC1n l\u1EE3i c\u1EE7a ng\u01B0\u1EDDi mua (ng\u01B0\u1EDDi ti\xEAu d\xF9ng). V\xEC v\u1EADy, \u0111\u1EC1 ngh\u1ECB c\xE1c th\xE0nh vi\xEAn b\xE1n d\u1ECBch v\u1EE5 tr\xEAn s\xE0n cung c\u1EA5p \u0111\u1EA7y \u0111\u1EE7, ch\xEDnh x\xE1c, trung th\u1EF1c v\xE0 chi ti\u1EBFt c\xE1c th\xF4ng tin li\xEAn quan \u0111\u1EBFn d\u1ECBch v\u1EE5. M\u1ECDi h\xE0nh vi l\u1EEBa \u0111\u1EA3o, gian l\u1EADn trong kinh doanh \u0111\u1EC1u b\u1ECB l\xEAn \xE1n v\xE0 ph\u1EA3i ch\u1ECBu ho\xE0n to\xE0n tr\xE1ch nhi\u1EC7m tr\u01B0\u1EDBc ph\xE1p lu\u1EADt.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'C\xE1c Lookme.vnao g\u1ED3m ng\u01B0\u1EDDi cung c\u1EA5p d\u1ECBch v\u1EE5, ng\u01B0\u1EDDi mua s\u1EBD ph\u1EA3i c\xF3 vai tr\xF2 tr\xE1ch nhi\u1EC7m trong vi\u1EC7c t\xEDch c\u1EF1c gi\u1EA3i quy\u1EBFt v\u1EA5n \u0111\u1EC1. \u0110\u1ED1i v\u1EDBi ng\u01B0\u1EDDi cung c\u1EA5p d\u1ECBch v\u1EE5 c\u1EA7n c\xF3 tr\xE1ch nhi\u1EC7m cung c\u1EA5p v\u0103n b\u1EA3n gi\u1EA5y t\u1EDD ch\u1EE9ng th\u1EF1c th\xF4ng tin li\xEAn quan \u0111\u1EBFn s\u1EF1 vi\u1EC7c \u0111ang g\xE2y m\xE2u thu\u1EABn cho kh\xE1ch h\xE0ng. \u0110\u1ED1i v\u1EDBi Lookme.vn s\u1EBD c\xF3 tr\xE1ch cung c\u1EA5p nh\u1EEFng th\xF4ng tin li\xEAn quan \u0111\u1EBFn ng\u01B0\u1EDDi mua v\xE0 ng\u01B0\u1EDDi cung c\u1EA5p d\u1ECBch v\u1EE5 n\u1EBFu \u0111\u01B0\u1EE3c ng\u01B0\u1EDDi mua ho\u1EB7c ng\u01B0\u1EDDi cung c\u1EA5p d\u1ECBch v\u1EE5 (li\xEAn quan \u0111\u1EBFn tranh ch\u1EA5p \u0111\xF3) y\xEAu c\u1EA7u.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Sau khi ng\u01B0\u1EDDi cung c\u1EA5p d\u1ECBch v\u1EE5, ng\u01B0\u1EDDi mua \u0111\xE3 gi\u1EA3i quy\u1EBFt xong tranh ch\u1EA5p ph\u1EA3i c\xF3 tr\xE1ch nhi\u1EC7m b\xE1o l\u1EA1i cho ban qu\u1EA3n tr\u1ECB Lookme.vn . Trong tr\u01B0\u1EDDng h\u1EE3p giao d\u1ECBch ph\xE1t sinh m\xE2u thu\u1EABn m\xE0 l\u1ED7i thu\u1ED9c v\u1EC1 ng\u01B0\u1EDDi cung c\u1EA5p d\u1ECBch v\u1EE5: Lookme.vn s\u1EBD c\xF3 bi\u1EC7n ph\xE1p c\u1EA3nh c\xE1o, kh\xF3a t\xE0i kho\u1EA3n ho\u1EB7c chuy\u1EC3n cho c\u01A1 quan ph\xE1p lu\u1EADt c\xF3 th\u1EA9m quy\u1EC1n t\xF9y theo m\u1EE9c \u0111\u1ED9 c\u1EE7a sai ph\u1EA1m. Lookme.vn s\u1EBD ch\u1EA5m d\u1EE9t v\xE0 g\u1EE1 b\u1ECF to\xE0n b\u1ED9 tin b\xE0i v\u1EC1 d\u1ECBch v\u1EE5 c\u1EE7a ng\u01B0\u1EDDi cung c\u1EA5p d\u1ECBch v\u1EE5 \u0111\xF3 tr\xEAn Lookme.vn \u0111\u1ED3ng th\u1EDDi y\xEAu c\u1EA7u ng\u01B0\u1EDDi cung c\u1EA5p d\u1ECBch v\u1EE5 b\u1ED3i ho\xE0n cho kh\xE1ch h\xE0ng th\u1ECFa \u0111\xE1ng tr\xEAn c\u01A1 s\u1EDF th\u1ECFa thu\u1EADn v\u1EDBi kh\xE1ch h\xE0ng.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'N\u1EBFu th\xF4ng qua h\xECnh th\u1EE9c th\u1ECFa thu\u1EADn m\xE0 v\u1EABn kh\xF4ng th\u1EC3 gi\u1EA3i quy\u1EBFt \u0111\u01B0\u1EE3c m\xE2u thu\u1EABn ph\xE1t sinh t\u1EEB giao d\u1ECBch gi\u1EEFa 2 b\xEAn ng\u01B0\u1EDDi mua, ng\u01B0\u1EDDi cung c\u1EA5p d\u1ECBch v\u1EE5, th\xEC m\u1ED9t trong 2 b\xEAn ng\u01B0\u1EDDi mua v\xE0 ng\u01B0\u1EDDi cung c\u1EA5p d\u1ECBch v\u1EE5 s\u1EBD c\xF3 quy\u1EC1n nh\u1EDD \u0111\u1EBFn c\u01A1 quan ph\xE1p lu\u1EADt c\xF3 th\u1EA9m quy\u1EC1n can thi\u1EC7p nh\u1EB1m \u0111\u1EA3m b\u1EA3o l\u1EE3i \xEDch h\u1EE3p ph\xE1p c\u1EE7a c\xE1c b\xEAn nh\u1EA5t l\xE0 cho kh\xE1ch h\xE0ng.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              'Quy tr\xECnh thanh to\xE1n :'
            )
          )
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              _react2.default.createElement(
                'i',
                null,
                'Thanh to\xE1n gi\u1EEFa ng\u01B0\u1EDDi ng\u01B0\u01A1i mua \u2013 ng\u01B0\u1EDDi b\xE1n ( Kh\xE1ch h\xE0ng v\xE0 \u0111\u1ED1i t\xE1c)'
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u0110\u1ED1i v\u1EDBi giao d\u1ECBch \u0111\u1EB7t v\xE0 s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 l\xE0m \u0111\u1EB9p t\u1EA1i c\xE1c \u0111\u1ECBa \u0111i\u1EC3m \u0111\u01B0\u1EE3c chia s\u1EBB tr\xEAn Lookme.vn th\xEC vi\u1EC7c thanh to\xE1n l\xE0 th\u1ECFa thu\u1EADn ri\xEAng gi\u1EEFa kh\xE1ch h\xE0ng v\xE0 NCC, Lookme.vn kh\xF4ng tham gia v\xE0o qu\xE1 tr\xECnh giao d\u1ECBch ngo\xE0i websiste n\xE0y. Kh\xE1ch h\xE0ng v\xE0 \u0110\u1ED1i t\xE1c cung c\u1EA5p d\u1ECBch v\u1EE5 t\u1EF1 th\u1ECFa thu\u1EADn v\xE0 quy\u1EBFt \u0111\u1ECBnh h\xECnh th\u1EE9c thanh to\xE1n d\u1ECBch v\u1EE5.'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              _react2.default.createElement(
                'i',
                null,
                'Thanh to\xE1n gi\u1EEFa kh\xE1ch h\xE0ng v\xE0 Lookme:'
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Hi\u1EC7n nay Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn ch\u01B0a t\xEDch h\u1EE3p ch\u1EE9c n\u0103ng thanh to\xE1n tr\u1EF1c tuy\u1EBFn cho c\xE1c s\u1EA3n ph\u1EA9m/ d\u1ECBch v\u1EE5 \u0111\u0103ng b\xE1n tr\xEAn website n\xEAn kh\xE1ch h\xE0ng sau khi \u0111\u1EB7t mua d\u1ECBch v\u1EE5 s\u1EBD tr\u1EA3 ph\xED d\u1ECBch v\u1EE5 b\u1EB1ng c\xE1ch thanh to\xE1n online qua th\u1EBB t\xEDn d\u1EE5ng, chuy\u1EC3n kho\u1EA3n'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            'B\u01B0\u1EDBc 1: Kh\xE1ch h\xE0ng t\xECm hi\u1EC3u th\xF4ng tin v\u1EC1 d\u1ECBch v\u1EE5 mu\u1ED1n l\xE0m, th\xF4ng tin v\u1EC1 \u0110\u1ECBa \u0111i\u1EC3m l\xE0m \u0111\u1EB9p c\u0169ng nh\u01B0 \u0111\u1ECBa \u0111i\u1EC3m ph\xF9 h\u1EE3p r\u1ED3i ti\u1EBFn h\xE0nh \u0111\u1EB7t l\u1ECBch l\xE0m \u0111\u1EB9p;'
          ),
          _react2.default.createElement(
            'li',
            null,
            'B\u01B0\u1EDBc 2: Nh\xE2n vi\xEAn Lookme.vn sau khi nh\u1EADn \u0111\u01B0\u1EE3c \u0111\u01A1n h\xE0ng s\u1EBD x\xE1c nh\u1EADn \u0111\u1EB7t d\u1ECBch v\u1EE5 qua mail ho\u1EB7c \u0111i\u1EC7n tho\u1EA1i, tin nh\u1EAFn SMS v\xE0 g\u1EEDi th\xF4ng tin t\xE0i kho\u1EA3n \u0111\u1EC3 kh\xE1ch h\xE0ng ti\u1EBFn h\xE0nh thanh to\xE1n;'
          ),
          _react2.default.createElement(
            'li',
            null,
            'B\u01B0\u1EDBc 3: Kh\xE1ch h\xE0ng x\xE1c nh\u1EADn d\u1ECBch v\u1EE5 v\xE0 thanh to\xE1n chuy\u1EC3n kho\u1EA3n cho Lookme.vn;',
            ' '
          ),
          _react2.default.createElement(
            'li',
            null,
            'B\u01B0\u1EDBc 4: Lookme.vn g\u1EEDi x\xE1c nh\u1EADn thanh to\xE1n th\xE0nh c\xF4ng cho kh\xE1ch h\xE0ng v\xE0 c\u1EADp nh\u1EADt trang th\xE1i thanh to\xE1n m\xE3 code (QR code) c\u1EE7a kh\xE1ch h\xE0ng tr\xEAn \u1EE9ng d\u1EE5ng l\xE0m \u0111\u1EB9p Lookme;'
          ),
          _react2.default.createElement(
            'li',
            null,
            'B\u01B0\u1EDBc 5: Kh\xE1ch h\xE0ng \u0111\u1EBFn \u0110\u1ECBa \u0111i\u1EC3m l\xE0m \u0111\u1EB9p \u0111\u01B0a m\xE3 code v\xE0 s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 \u0111\xE3 \u0111\u1EB7t.'
          )
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              _react2.default.createElement(
                'i',
                null,
                'Thanh to\xE1n gi\u1EEFa \u0111\u1ED1i t\xE1c (ng\u01B0\u1EDDi b\xE1n, nh\xE0 cung c\u1EA5p\u2026) v\xE0 Lookme.vn:'
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u0110\u1ED1i v\u1EDBi website Lookme.vn ch\u01B0a cung c\u1EA5p d\u1ECBch v\u1EE5 \u0111\u1EB7t l\u1ECBch tr\u1EF1c tuy\u1EBFn n\xEAn Lookme.vn kh\xF4ng thu ph\xED t\u1EA1o ph\xE1t sinh \u0111\u01A1n h\xE0ng trong gian h\xE0ng c\u1EE7a \u0111\u1ED1i t\xE1c. Nh\xE0 cung c\u1EA5p s\u1EBD chi tr\u1EA3 cho Lookme.vn m\u1ED9t m\u1EE9c hoa h\u1ED3ng (t\u1EEB 15% - 20%) v\u1EC1 d\u1ECBch v\u1EE5 ph\xE1t h\xE0nh voucher/ deal khuy\u1EBFn m\xE3i.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Lookme.vn s\u1EBD thanh to\xE1n cho \u0110\u1ED1i t\xE1c nhi\u1EC1u \u0111\u1EE3t. \u0110\u1EC3 c\xF3 c\u01A1 s\u1EDF th\u1EF1c hi\u1EC7n vi\u1EC7c thanh to\xE1n \u0111\u01B0\u1EE3c quy \u0111\u1ECBnh t\u1EA1i H\u1EE3p \u0111\u1ED3ng, C\xE1c B\xEAn s\u1EBD ti\u1EBFn h\xE0nh \u0111\u1ED1i so\xE1t v\xE0 thanh to\xE1n \u0111\u01B0\u1EE3c th\u1EF1c hi\u1EC7n theo c\xE1c b\u01B0\u1EDBc sau \u0111\xE2y:'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              'Giai \u0111o\u1EA1n 01: ch\u01B0a \u0111\u1ED1i chi\u1EBFu voucher'
            )
          )
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            '\u0110\u1EE3t 1: V\xE0o ng\xE0y th\u1EE9 12 k\u1EC3 t\u1EEB ng\xE0y l\xEAn deal ( n\u1EBFu r\u01A1i v\xE0o ng\xE0y th\u1EE9 7 v\xE0 ch\u1EE7 nh\u1EADt th\xEC ng\xE0y thanh to\xE1n s\u1EBD l\xE0 ng\xE0y th\u1EE9 2), Lookme.vn s\u1EBD ch\u1EE7 \u0111\u1ED9ng h\u1EB9n v\xE0 thanh to\xE1n cho \u0110\u1ED1i t\xE1c b\u1EB1ng ti\u1EC1n m\u1EB7t ho\u1EB7c chuy\u1EC3n kho\u1EA3n 50% doanh thu c\u1EE7a deal t\u1EEB ng\xE0y th\u1EE9 01 \u0111\u1EBFn ng\xE0y th\u1EE9 10 (sau khi tr\u1EEB ra chi ph\xED d\u1ECBch v\u1EE5 c\u1EE7a Lookme.vn). Lookme.vn xu\u1EA5t h\xF3a \u0111\u01A1n t\xE0i ch\xEDnh ghi nh\u1EADn ti\u1EC1n chi ph\xED d\u1ECBch v\u1EE5 \u0111\u1EE3t 01 m\xE0 Lookme.vn \u0111\u01B0\u1EE3c h\u01B0\u1EDFng ngay t\u1EA1i th\u1EDDi \u0111i\u1EC3m n\xE0y.'
          ),
          _react2.default.createElement(
            'li',
            null,
            '\u0110\u1EE3t 2: V\xE0o ng\xE0y th\u1EE9 22 k\u1EC3 t\u1EEB ng\xE0y l\xEAn deal ( n\u1EBFu r\u01A1i v\xE0o ng\xE0y th\u1EE9 7 v\xE0 ch\u1EE7 nh\u1EADt th\xEC ng\xE0y thanh to\xE1n s\u1EBD l\xE0 ng\xE0y th\u1EE9 2), Lookme.vn s\u1EBD ch\u1EE7 \u0111\u1ED9ng h\u1EB9n v\xE0 thanh to\xE1n ti\u1EBFp cho \u0110\u1ED1i t\xE1c b\u1EB1ng ti\u1EC1n m\u1EB7t ho\u1EB7c chuy\u1EC3n kho\u1EA3n 50% doanh thu ph\xE1t sinh c\u1EE7a deal t\u1EEB ng\xE0y th\u1EE9 11 \u0111\u1EBFn ng\xE0y th\u1EE9 20 (sau khi tr\u1EEB ra chi ph\xED d\u1ECBch v\u1EE5 c\u1EE7a Lookme.vn). Lookme.vn xu\u1EA5t h\xF3a \u0111\u01A1n t\xE0i ch\xEDnh ghi nh\u1EADn ti\u1EC1n chi ph\xED d\u1ECBch v\u1EE5 \u0111\u1EE3t 2 m\xE0 Lookme.vn \u0111\u01B0\u1EE3c h\u01B0\u1EDFng ngay t\u1EA1i th\u1EDDi \u0111i\u1EC3m n\xE0y.'
          )
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              'Giai \u0111o\u1EA1n 02: s\u1EBD \u0111\u1ED1i chi\u1EBFu voucher '
            )
          )
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            '\u0110\u1EE3t 3: V\xE0o ng\xE0y th\u1EE9 31 k\u1EC3 t\u1EEB ng\xE0y l\xEAn deal ( n\u1EBFu r\u01A1i v\xE0o ng\xE0y th\u1EE9 7 v\xE0 ch\u1EE7 nh\u1EADt th\xEC ng\xE0y thanh to\xE1n s\u1EBD l\xE0 ng\xE0y th\u1EE9 2), \u0110\u1ED1i t\xE1c c\xF3 tr\xE1ch nhi\u1EC7m t\u1ED5ng k\u1EBFt s\u1ED1 l\u01B0\u1EE3ng voucher m\xE0 kh\xE1ch h\xE0ng mang \u0111\u1EBFn s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5/s\u1EA3n ph\u1EA9m c\u1EE7a \u0110\u1ED1i t\xE1c sau \u0111\xF3 ch\u1EE7 \u0111\u1ED9ng li\xEAn h\u1EC7 k\u1EBF to\xE1n Lookme.vn \u0111\u1EC3 ti\u1EBFn h\xE0nh \u0111\u1ED1i chi\u1EBFu.'
          )
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            'N\u1EBFu s\u1ED1 l\u01B0\u1EE3ng voucher m\xE0 kh\xE1ch h\xE0ng mang \u0111\u1EBFn s\u1EED d\u1EE5ng \xEDt h\u01A1n s\u1ED1 l\u01B0\u1EE3ng voucher m\xE0 Lookme.vn \u0111\xE3 thanh to\xE1n cho \u0110\u1ED1i t\xE1c nh\u1EEFng \u0111\u1EE3t tr\u01B0\u1EDBc \u0111\xF3 th\xEC Lookme.vn kh\xF4ng ph\u1EA3i tr\u1EA3 th\xEAm ti\u1EC1n cho \u0110\u1ED1i t\xE1c.'
          ),
          _react2.default.createElement(
            'li',
            null,
            'N\u1EBFu s\u1ED1 l\u01B0\u1EE3ng voucher m\xE0 kh\xE1ch h\xE0ng mang \u0111\u1EBFn s\u1EED d\u1EE5ng nhi\u1EC1u h\u01A1n s\u1ED1 l\u01B0\u1EE3ng voucher m\xE0 Lookme.vn \u0111\xE3 thanh to\xE1n cho \u0110\u1ED1i t\xE1c nh\u1EEFng \u0111\u1EE3t tr\u01B0\u1EDBc \u0111\xF3 th\xEC Lookme.vn s\u1EBD thanh to\xE1n cho \u0110\u1ED1i t\xE1c s\u1ED1 l\u01B0\u1EE3ng voucher ch\xEAnh l\u1EC7ch nh\xE2n v\u1EDBi gi\xE1 b\xE1n voucher (sau khi tr\u1EEB ra chi ph\xED d\u1ECBch v\u1EE5 c\u1EE7a Lookme.vn).'
          )
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            'Nh\u1EEFng \u0111\u1EE3t k\u1EBF ti\u1EBFp: v\xE0o ng\xE0y th\u1EE9 61, 91, 121, 151\u2026. k\u1EC3 t\u1EEB ng\xE0y l\xEAn deal (n\u1EBFu r\u01A1i v\xE0o ng\xE0y th\u1EE9 7 v\xE0 ch\u1EE7 nh\u1EADt th\xEC ng\xE0y thanh to\xE1n s\u1EBD l\xE0 ng\xE0y th\u1EE9 2), ph\u01B0\u01A1ng th\u1EE9c thanh to\xE1n v\xE0 \u0111i\u1EC1u ki\u1EC7n th\u1EF1c hi\u1EC7n c\u0169ng gi\u1ED1ng nh\u01B0 \u0111\u1EE3t 3'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Lookme.vn xu\u1EA5t h\xF3a \u0111\u01A1n t\xE0i ch\xEDnh l\u1EA7n cu\u1ED1i ghi nh\u1EADn c\xE1c ph\xED d\u1ECBch v\u1EE5 c\u1EE7a c\xE1c \u0111\u1EE3t thanh to\xE1n t\u1EEB \u0111\u1EE3t 3 \u0111\u1EBFn \u0111\u1EE3t cu\u1ED1i c\xF9ng ch\u1EADm nh\u1EA5t trong v\xF2ng 07 ng\xE0y sau khi ti\u1EBFn tr\xECnh thanh to\xE1n deal ho\xE0n t\u1EA5t (khi voucher h\u1EBFt h\u1EA1n s\u1EED d\u1EE5ng). Hai b\xEAn th\u1ED1ng nh\u1EA5t h\xECnh th\u1EE9c thanh to\xE1n l\xE0: chuy\u1EC3n kho\u1EA3n qua ng\xE2n h\xE0ng'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              '\u0110\u1EA3m b\u1EA3o an to\xE0n giao d\u1ECBch:'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Nh\u1EB1m h\u1ED7 tr\u1EE3 vi\u1EC7c s\u1EED d\u1EE5ng c\xE1c d\u1ECBch v\u1EE5 c\u1EE7a Lookme.vn, c\xE1c th\xF4ng tin c\u1EE7a Kh\xE1ch h\xE0ng c\xF3 th\u1EC3 \u0111\u01B0\u1EE3c chia s\u1EBB v\u1EDBi c\xE1c c\xF4ng ty con l\xE0 th\xE0nh vi\xEAn c\u1EE7a gia \u0111\xECnh Lookme.vn. \u0110\u1EC3 t\xECm hi\u1EC3u th\xEAm nh\u1EEFng th\xF4ng tin Kh\xE1ch h\xE0ng c\u1EA7n bi\u1EBFt v\u1EC1 Lookme.vn v\xE0 c\xE1c C\xF4ng ty th\xE0nh vi\xEAn, vui l\xF2ng v\xE0o m\u1EE5c v\u1EC1 Lookme.vn.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 b\xEAn th\u1EE9 ba: Lookme.vn c\xF3 th\u1EC3 s\u1EED d\u1EE5ng nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 \u0111\u1EC3 thay m\u1EB7t Lookme.vn x\u1EED l\xFD th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a Kh\xE1ch h\xE0ng. Vi\u1EC7c n\xE0y ph\u1EE5c v\u1EE5 nhi\u1EC1u m\u1EE5c \u0111\xEDch, bao g\u1ED3m vi\u1EC7c g\u1EEDi th\xF4ng tin ti\u1EBFp th\u1ECB. Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 b\xEAn th\u1EE9 ba ph\u1EA3i tu\xE2n th\u1EE7 c\xE1c \u0111i\u1EC1u kho\u1EA3n v\u1EC1 b\u1EA3o m\u1EADt, do \u0111\xF3 s\u1EBD kh\xF4ng \u0111\u01B0\u1EE3c ph\xE9p s\u1EED d\u1EE5ng th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a Kh\xE1ch h\xE0ng cho c\xE1c m\u1EE5c \u0111\xEDch kh\xE1c.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 thanh to\xE1n v\xE0 c\xE1c t\u1ED5 ch\u1EE9c t\xE0i ch\xEDnh (kh\xE1c): Khi Kh\xE1ch h\xE0ng ho\u1EB7c ch\u1EE7 c\u1EE7a th\u1EBB t\xEDn d\u1EE5ng \u0111\u01B0\u1EE3c d\xF9ng \u0111\u1EC3 \u0111\u1EB7t d\u1ECBch v\u1EE5 cho Kh\xE1ch h\xE0ng y\xEAu c\u1EA7u ti\u1EC1n b\u1ED3i ho\xE0n cho \u0111\u1EB7t d\u1ECBch v\u1EE5 c\u1EE7a Kh\xE1ch h\xE0ng, Lookme.vn c\xF3 th\u1EC3 c\u1EA7n ph\u1EA3i chia s\u1EBB m\u1ED9t s\u1ED1 th\xF4ng tin nh\u1EA5t \u0111\u1ECBnh v\u1EC1 \u0111\u1EB7t d\u1ECBch v\u1EE5 v\u1EDBi nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 thanh to\xE1n v\xE0 t\u1ED5 ch\u1EE9c t\xE0i ch\xEDnh c\xF3 li\xEAn quan \u0111\u1EC3 x\u1EED l\xFD vi\u1EC7c b\u1ED3i ho\xE0n. Th\xF4ng tin n\xE0y c\xF3 th\u1EC3 bao g\u1ED3m b\u1EA3n sao x\xE1c nh\u1EADn \u0111\u1EB7t d\u1ECBch v\u1EE5 c\u1EE7a Kh\xE1ch h\xE0ng ho\u1EB7c \u0111\u1ECBa ch\u1EC9 IP \u0111\xE3 d\xF9ng \u0111\u1EC3 th\u1EF1c hi\u1EC7n \u0111\u1EB7t d\u1ECBch v\u1EE5. Lookme.vn c\xF3 th\u1EC3 chia s\u1EBB th\xEAm th\xF4ng tin v\u1EDBi c\xE1c t\u1ED5 ch\u1EE9c t\xE0i ch\xEDnh c\xF3 li\xEAn quan n\u1EBFu nh\u1EADn th\u1EA5y th\u1EF1c s\u1EF1 c\u1EA7n thi\u1EBFt cho m\u1EE5c \u0111\xEDch ph\xE1t hi\u1EC7n v\xE0 ph\xF2ng tr\xE1nh gian l\u1EADn.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Nh\xE0 ch\u1EE9c tr\xE1ch c\xF3 th\u1EA9m quy\u1EC1n: Lookme.vn c\u1EA7n ph\u1EA3i ti\u1EBFt l\u1ED9 th\xF4ng tin c\xE1 nh\xE2n cho c\u01A1 quan th\u1EF1c thi ph\xE1p lu\u1EADt theo quy \u0111\u1ECBnh c\u1EE7a ph\xE1p lu\u1EADt ho\u1EB7c khi th\u1EF1c s\u1EF1 c\u1EA7n thi\u1EBFt cho vi\u1EC7c \u0111\u1EC1 ph\xF2ng, ph\xE1t hi\u1EC7n ho\u1EB7c truy c\u1EE9u c\xE1c h\xE0nh vi ph\u1EA1m t\u1ED9i ho\u1EB7c gian l\u1EADn. Lookme.vn c\xF3 th\u1EC3 c\u1EA7n ti\u1EBFt l\u1ED9 th\xEAm th\xF4ng tin c\xE1 nh\xE2n cho nh\xE0 ch\u1EE9c tr\xE1ch c\xF3 th\u1EA9m quy\u1EC1n nh\u1EB1m b\u1EA3o v\u1EC7 v\xE0 b\xE0o ch\u1EEFa cho quy\u1EC1n l\u1EE3i v\xE0 t\xE0i s\u1EA3n c\u1EE7a Lookme.vn ho\u1EB7c c\u1EE7a \u0111\u1ED1i t\xE1c kinh doanh c\u1EE7a Lookme.vn.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Khi Kh\xE1ch h\xE0ng th\u1EF1c hi\u1EC7n m\u1ED9t \u0111\u1EB7t d\u1ECBch v\u1EE5 tr\xEAn trang webite c\u1EE7a m\u1ED9t trong c\xE1c \u0111\u1ED1i t\xE1c kinh doanh c\u1EE7a Lookme.vn, m\u1ED9t s\u1ED1 th\xF4ng tin c\xE1 nh\xE2n nh\u1EA5t \u0111\u1ECBnh m\xE0 Kh\xE1ch h\xE0ng cung c\u1EA5p cho h\u1ECD s\u1EBD \u0111\u01B0\u1EE3c chuy\u1EC3n ti\u1EBFp cho Lookme.vn. N\u1EBFu d\u1ECBch v\u1EE5 kh\xE1ch h\xE0ng \u0111\u01B0\u1EE3c cung c\u1EA5p b\u1EDFi \u0111\u1ED1i t\xE1c kinh doanh, Lookme.vn s\u1EBD chia s\u1EBB c\xE1c chi ti\u1EBFt li\xEAn quan \u0111\u1EBFn \u0111\u1EB7t d\u1ECBch v\u1EE5 c\u1EE7a Kh\xE1ch h\xE0ng v\u1EDBi c\xE1c \u0111\u1ED1i t\xE1c kinh doanh (khi c\u1EA7n thi\u1EBFt) \u0111\u1EC3 cung c\u1EA5p cho Kh\xE1ch h\xE0ng h\u1ED7 tr\u1EE3 ph\xF9 h\u1EE3p v\xE0 hi\u1EC7u qu\u1EA3. Khi Kh\xE1ch h\xE0ng th\u1EF1c hi\u1EC7n m\u1ED9t \u0111\u1EB7t d\u1ECBch v\u1EE5 th\xF4ng qua trang web c\u1EE7a m\u1ED9t trong c\xE1c \u0111\u1ED1i t\xE1c kinh doanh c\u1EE7a Lookme.vn, c\xE1c \u0111\u1ED1i t\xE1c kinh doanh c\xF3 th\u1EC3 nh\u1EADn m\u1ED9t s\u1ED1 th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a Kh\xE1ch h\xE0ng li\xEAn quan \u0111\u1EBFn \u0111\u1EB7t d\u1ECBch v\u1EE5 c\u1EE5 th\u1EC3. \u0110i\u1EC1u n\xE0y ph\u1EE5c v\u1EE5 cho m\u1EE5c \u0111\xEDch n\u1ED9i b\u1ED9 ri\xEAng c\u1EE7a h\u1ECD (v\xED d\u1EE5 nh\u01B0 m\u1EE5c \u0111\xEDch ph\xE2n t\xEDch) v\xE0 vi\u1EC7c qu\u1EA3n l\xFD c\xE1c ch\u01B0\u01A1ng tr\xECnh kh\xE1ch h\xE0ng th\xE2n thi\u1EBFt ho\u1EB7c ti\u1EBFp th\u1ECB, n\u1EBFu nh\u01B0 Kh\xE1ch h\xE0ng y\xEAu c\u1EA7u.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Lookme.vn s\u1EED d\u1EE5ng h\u1EC7 th\u1ED1ng kinh doanh v\xE0 quy \u0111\u1ECBnh th\xEDch h\u1EE3p \u0111\u1EC3 b\u1EA3o v\u1EC7 v\xE0 gi\u1EEF g\xECn nh\u1EEFng th\xF4ng tin c\xE1 nh\xE2n Kh\xE1ch h\xE0ng \u0111\xE3 cung c\u1EA5p. Lookme.vn c\u0169ng s\u1EED d\u1EE5ng c\xE1c quy tr\xECnh an to\xE0n v\xE0 r\xE0o c\u1EA3n v\u1EC1 m\u1EB7t k\u1EF9 thu\u1EADt v\xE0 c\u01A1 s\u1EDF v\u1EADt ch\u1EA5t \u0111\u1EC3 h\u1EA1n ch\u1EBF vi\u1EC7c truy c\u1EADp v\xE0 s\u1EED d\u1EE5ng th\xF4ng tin c\xE1 nh\xE2n tr\xEAn server c\u1EE7a Lookme.vn. Ch\u1EC9 c\xF3 nh\u1EEFng nh\xE2n vi\xEAn \u0111\u01B0\u1EE3c \u1EE7y quy\u1EC1n m\u1EDBi c\xF3 quy\u1EC1n truy c\u1EADp v\xE0o c\xE1c th\xF4ng tin c\xE1 nh\xE2n nh\u1EB1m ph\u1EE5c v\u1EE5 cho c\xF4ng vi\u1EC7c c\u1EE7a h\u1ECD.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Khi chi ti\u1EBFt th\u1EBB t\xEDn d\u1EE5ng c\u1EE7a Kh\xE1ch h\xE0ng c\u1EA7n \u0111\u01B0\u1EE3c cung c\u1EA5p nh\u01B0 m\u1ED9t ph\u1EA7n c\u1EE7a qu\xE1 tr\xECnh \u0111\u1EB7t d\u1ECBch v\u1EE5, th\xF4ng tin n\xE0y s\u1EBD \u0111\u01B0\u1EE3c Lookme.vn l\u01B0u tr\u1EEF trong v\xF2ng t\u1ED1i \u0111a 45 ng\xE0y. Sau \u0111\xF3, th\xF4ng tin th\u1EBB t\xEDn d\u1EE5ng c\u1EE7a Kh\xE1ch h\xE0ng (m\u1ED9t ph\u1EA7n ho\u1EB7c to\xE0n b\u1ED9) s\u1EBD \u0111\u01B0\u1EE3c x\xF3a v\u0129nh vi\u1EC5n kh\u1ECFi h\u1EC7 th\u1ED1ng c\u1EE7a Lookme.vn ho\u1EB7c \u0111\u01B0\u1EE3c gi\u1EEF l\u1EA1i m\u1ED9t c\xE1ch an to\xE0n, h\u1EA1n ch\u1EBF truy c\u1EADp, nh\u1EB1m m\u1EE5c \u0111\xEDch ph\xE1t hi\u1EC7n gian l\u1EADn. Kh\xE1ch h\xE0ng c\u0169ng c\xF3 th\u1EC3 l\u01B0u chi ti\u1EBFt th\u1EBB t\xEDn d\u1EE5ng trong t\xE0i kho\u1EA3n c\u1EE7a m\xECnh. Khi \u0111\xF3 chi ti\u1EBFt th\u1EBB t\xEDn d\u1EE5ng c\u1EE7a Kh\xE1ch h\xE0ng s\u1EBD \u0111\u01B0\u1EE3c l\u01B0u d\u01B0\u1EDBi d\u1EA1ng b\u1EA3ng b\u0103m (hashed form) ngo\u1EA1i tr\u1EEB 4 ch\u1EEF s\u1ED1 cu\u1ED1i c\xF9ng c\u1EE7a s\u1ED1 th\u1EBB t\xEDn d\u1EE5ng. B\u1EB1ng c\xE1ch n\xE0y Kh\xE1ch h\xE0ng s\u1EBD bi\u1EBFt m\xECnh s\u1EBD d\xF9ng th\u1EBB n\xE0o khi thanh to\xE1n.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Lookme.vn ki\u1EC3m so\xE1t qu\xE1 tr\xECnh x\u1EED l\xFD d\u1EEF li\u1EC7u c\xE1 nh\xE2n tr\xEAn c\xE1c trang web v\xE0 \u1EE9ng d\u1EE5ng di \u0111\u1ED9ng c\u1EE7a Lookme.vn. RevMax l\xE0 c\xF4ng ty tr\xE1ch nhi\u1EC7m h\u1EEFu h\u1EA1n t\u01B0 nh\xE2n, \u0111\u01B0\u1EE3c th\xE0nh l\u1EADp theo lu\u1EADt ph\xE1p Vi\u1EC7t Nam v\xE0 c\xF3 v\u0103n ph\xF2ng t\u1EA1i 145 Nguy\u1EC5n C\u1EEDu V\xE2n, Ph\u01B0\u1EDDng 17, Qu\u1EADn B\xECnh Th\u1EA1nh, Tp.HCM, Vi\u1EC7t Nam. N\u1EBFu Kh\xE1ch h\xE0ng c\xF3 ki\u1EBFn ngh\u1ECB ho\u1EB7c nh\u1EADn x\xE9t li\xEAn quan \u0111\u1EBFn ch\xEDnh s\xE1ch b\u1EA3o m\u1EADt n\xE0y, vui l\xF2ng email \u0111\u1EBFn customer.care@Lookme.vn v\xE0 Lookme.vn s\u1EBD ph\u1EA3n h\u1ED3i ngay cho Kh\xE1ch h\xE0ng. \u0110\u1ED1i v\u1EDBi nh\u1EEFng v\u1EA5n \u0111\u1EC1 li\xEAn quan \u0111\u1EBFn an to\xE0n b\u1EA3o m\u1EADt, Lookme.vn lu\xF4n s\u1EB5n s\xE0ng gi\u1EA3i \u0111\xE1p.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              'B\u1EA3o v\u1EC7 th\xF4ng tin c\xE1 nh\xE2n kh\xE1ch h\xE0ng'
            )
          )
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'b',
                        null,
                        _react2.default.createElement(
                          'i',
                          null,
                          'M\u1EE5c \u0111\xEDch thu th\u1EADp th\xF4ng tin c\xE1 nh\xE2n'
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Vi\u1EC7c thu th\u1EADp d\u1EEF li\u1EC7u ch\u1EE7 y\u1EBFu tr\xEAn Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn bao g\u1ED3m: email, \u0111i\u1EC7n tho\u1EA1i, t\xEAn \u0111\u0103ng nh\u1EADp, m\u1EADt kh\u1EA9u \u0111\u0103ng nh\u1EADp, \u0111\u1ECBa ch\u1EC9 kh\xE1ch h\xE0ng (th\xE0nh vi\xEAn). \u0110\xE2y l\xE0 c\xE1c th\xF4ng tin m\xE0 Lookme.vn c\u1EA7n th\xE0nh vi\xEAn cung c\u1EA5p b\u1EAFt bu\u1ED9c khi \u0111\u0103ng k\xFD s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 v\xE0 \u0111\u1EC3 Lookme.vn li\xEAn h\u1EC7 x\xE1c nh\u1EADn khi kh\xE1ch h\xE0ng \u0111\u0103ng k\xFD s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 tr\xEAn website nh\u1EB1m \u0111\u1EA3m b\u1EA3o quy\u1EC1n l\u1EE3i cho cho ng\u01B0\u1EDDi ti\xEAu d\xF9ng.',
          ' '
        ),
        _react2.default.createElement(
          'p',
          null,
          'C\xE1c th\xE0nh vi\xEAn s\u1EBD t\u1EF1 ch\u1ECBu tr\xE1ch nhi\u1EC7m v\u1EC1 b\u1EA3o m\u1EADt v\xE0 l\u01B0u gi\u1EEF m\u1ECDi ho\u1EA1t \u0111\u1ED9ng s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 d\u01B0\u1EDBi t\xEAn \u0111\u0103ng k\xFD, m\u1EADt kh\u1EA9u v\xE0 h\u1ED9p th\u01B0 \u0111i\u1EC7n t\u1EED c\u1EE7a m\xECnh. Ngo\xE0i ra, th\xE0nh vi\xEAn c\xF3 tr\xE1ch nhi\u1EC7m th\xF4ng b\xE1o k\u1ECBp th\u1EDDi cho Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn v\u1EC1 nh\u1EEFng h\xE0nh vi s\u1EED d\u1EE5ng tr\xE1i ph\xE9p, l\u1EA1m d\u1EE5ng, vi ph\u1EA1m b\u1EA3o m\u1EADt, l\u01B0u gi\u1EEF t\xEAn \u0111\u0103ng k\xFD v\xE0 m\u1EADt kh\u1EA9u c\u1EE7a b\xEAn th\u1EE9 ba \u0111\u1EC3 c\xF3 bi\u1EC7n ph\xE1p gi\u1EA3i quy\u1EBFt ph\xF9 h\u1EE3p.',
          ' '
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'b',
                        null,
                        _react2.default.createElement(
                          'i',
                          null,
                          'Ph\u1EA1m vi thu th\u1EADp th\xF4ng tin'
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn s\u1EED d\u1EE5ng th\xF4ng tin th\xE0nh vi\xEAn cung c\u1EA5p \u0111\u1EC3:'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            'Cung c\u1EA5p c\xE1c d\u1ECBch v\u1EE5 \u0111\u1EBFn Th\xE0nh vi\xEAn;'
          ),
          _react2.default.createElement(
            'li',
            null,
            'G\u1EEDi c\xE1c th\xF4ng b\xE1o v\u1EC1 c\xE1c ho\u1EA1t \u0111\u1ED9ng trao \u0111\u1ED5i th\xF4ng tin gi\u1EEFa th\xE0nh vi\xEAn v\xE0 Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn;'
          ),
          _react2.default.createElement(
            'li',
            null,
            'Ng\u0103n ng\u1EEBa c\xE1c ho\u1EA1t \u0111\u1ED9ng ph\xE1 h\u1EE7y t\xE0i kho\u1EA3n ng\u01B0\u1EDDi d\xF9ng c\u1EE7a th\xE0nh vi\xEAn ho\u1EB7c c\xE1c ho\u1EA1t \u0111\u1ED9ng gi\u1EA3 m\u1EA1o Th\xE0nh vi\xEAn;'
          ),
          _react2.default.createElement(
            'li',
            null,
            'Li\xEAn l\u1EA1c v\xE0 gi\u1EA3i quy\u1EBFt v\u1EDBi th\xE0nh vi\xEAn trong nh\u1EEFng tr\u01B0\u1EDDng h\u1EE3p \u0111\u1EB7c bi\u1EC7t.'
          ),
          _react2.default.createElement(
            'li',
            null,
            'Kh\xF4ng s\u1EED d\u1EE5ng th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a th\xE0nh vi\xEAn ngo\xE0i m\u1EE5c \u0111\xEDch x\xE1c nh\u1EADn v\xE0 li\xEAn h\u1EC7 c\xF3 li\xEAn quan \u0111\u1EBFn giao d\u1ECBch t\u1EA1i Lookme.vn.'
          ),
          _react2.default.createElement(
            'li',
            null,
            'Trong tr\u01B0\u1EDDng h\u1EE3p c\xF3 y\xEAu c\u1EA7u c\u1EE7a ph\xE1p lu\u1EADt: Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn c\xF3 tr\xE1ch nhi\u1EC7m h\u1EE3p t\xE1c cung c\u1EA5p th\xF4ng tin c\xE1 nh\xE2n th\xE0nh vi\xEAn khi c\xF3 y\xEAu c\u1EA7u t\u1EEB c\u01A1 quan t\u01B0 ph\xE1p bao g\u1ED3m: Vi\u1EC7n ki\u1EC3m s\xE1t, t\xF2a \xE1n, c\u01A1 quan c\xF4ng an \u0111i\u1EC1u tra li\xEAn quan \u0111\u1EBFn h\xE0nh vi vi ph\u1EA1m ph\xE1p lu\u1EADt n\xE0o \u0111\xF3 c\u1EE7a kh\xE1ch h\xE0ng. Ngo\xE0i ra, kh\xF4ng ai c\xF3 quy\u1EC1n x\xE2m ph\u1EA1m v\xE0o th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a th\xE0nh vi\xEAn.'
          )
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'b',
                        null,
                        _react2.default.createElement(
                          'i',
                          null,
                          'Th\u1EDDi gian l\u01B0u tr\u1EEF th\xF4ng tin'
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'D\u1EEF li\u1EC7u c\xE1 nh\xE2n c\u1EE7a Th\xE0nh vi\xEAn s\u1EBD \u0111\u01B0\u1EE3c l\u01B0u tr\u1EEF cho \u0111\u1EBFn khi c\xF3 y\xEAu c\u1EA7u h\u1EE7y b\u1ECF ho\u1EB7c t\u1EF1 th\xE0nh vi\xEAn \u0111\u0103ng nh\u1EADp v\xE0 th\u1EF1c hi\u1EC7n h\u1EE7y b\u1ECF. C\xF2n l\u1EA1i trong m\u1ECDi tr\u01B0\u1EDDng h\u1EE3p th\xF4ng tin c\xE1 nh\xE2n th\xE0nh vi\xEAn s\u1EBD \u0111\u01B0\u1EE3c b\u1EA3o m\u1EADt tr\xEAn m\xE1y ch\u1EE7 c\u1EE7a Lookme.vn'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'b',
                        null,
                        _react2.default.createElement(
                          'i',
                          null,
                          '\u0110\u1ECBa ch\u1EC9 \u0111\u01A1n v\u1ECB thu th\u1EADp v\xE0 qu\u1EA3n l\xFD th\xF4ng tin c\xE1 nh\xE2n'
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            'C\xF4ng ty C\u1ED5 Ph\u1EA7n Lookme'
          ),
          _react2.default.createElement(
            'li',
            null,
            'V\u0103n ph\xF2ng giao d\u1ECBch: 481/14 \u0110\u01B0\u1EDDng s\u1ED1 10, Ph\u01B0\u1EDDng 8, Qu\u1EADn G\xF2 V\u1EA5p, Th\xE0nh ph\u1ED1 H\u1ED3 Ch\xED Minh'
          ),
          _react2.default.createElement(
            'li',
            null,
            'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i: 0933207298 Email: hr@lookme.vn'
          )
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'b',
                        null,
                        _react2.default.createElement(
                          'i',
                          null,
                          'Ph\u01B0\u01A1ng ti\u1EC7n v\xE0 c\xF4ng c\u1EE5 \u0111\u1EC3 ng\u01B0\u1EDDi d\xF9ng ti\u1EBFp c\u1EADn v\xE0 ch\u1EC9nh s\u1EEDa d\u1EEF li\u1EC7u c\xE1 nh\xE2n c\u1EE7a m\xECnh.'
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\xE0nh vi\xEAn c\xF3 quy\u1EC1n t\u1EF1 ki\u1EC3m tra, c\u1EADp nh\u1EADt, \u0111i\u1EC1u ch\u1EC9nh ho\u1EB7c h\u1EE7y b\u1ECF th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a m\xECnh b\u1EB1ng c\xE1ch \u0111\u0103ng nh\u1EADp v\xE0o t\xE0i kho\u1EA3n v\xE0 ch\u1EC9nh s\u1EEDa th\xF4ng tin c\xE1 nh\xE2n ho\u1EB7c y\xEAu c\u1EA7u Lookme.vn th\u1EF1c hi\u1EC7n vi\u1EC7c n\xE0y. Khi ti\u1EBFp nh\u1EADn nh\u1EEFng ph\u1EA3n h\u1ED3i n\xE0y, Lookme.vn s\u1EBD x\xE1c nh\u1EADn l\u1EA1i th\xF4ng tin, ph\u1EA3i c\xF3 tr\xE1ch nhi\u1EC7m tr\u1EA3 l\u1EDDi l\xFD do v\xE0 h\u01B0\u1EDBng d\u1EABn th\xE0nh vi\xEAn kh\xF4i ph\u1EE5c ho\u1EB7c x\xF3a b\u1ECF th\xF4ng tin c\xE1 nh\u1EADn kh\xE1ch h\xE0ng.'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'b',
                        null,
                        _react2.default.createElement(
                          'i',
                          null,
                          'Cam k\u1EBFt b\u1EA3o m\u1EADt th\xF4ng tin c\xE1 nh\xE2n kh\xE1ch h\xE0ng'
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a th\xE0nh vi\xEAn tr\xEAn Lookme.vn \u0111\u01B0\u1EE3c Lookme.vn cam k\u1EBFt b\u1EA3o m\u1EADt tuy\u1EC7t \u0111\u1ED1i theo ch\xEDnh s\xE1ch b\u1EA3o v\u1EC7 th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a Lookme.vn. Vi\u1EC7c thu th\u1EADp v\xE0 s\u1EED d\u1EE5ng th\xF4ng tin c\u1EE7a m\u1ED7i th\xE0nh vi\xEAn ch\u1EC9 \u0111\u01B0\u1EE3c th\u1EF1c hi\u1EC7n khi c\xF3 s\u1EF1 \u0111\u1ED3ng \xFD c\u1EE7a kh\xE1ch h\xE0ng \u0111\xF3 tr\u1EEB nh\u1EEFng tr\u01B0\u1EDDng h\u1EE3p ph\xE1p lu\u1EADt c\xF3 quy \u0111\u1ECBnh kh\xE1c.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Kh\xF4ng s\u1EED d\u1EE5ng, kh\xF4ng chuy\u1EC3n giao, cung c\u1EA5p hay ti\u1EBFt l\u1ED9 cho b\xEAn th\u1EE9 3 n\xE0o v\u1EC1 th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a th\xE0nh vi\xEAn khi kh\xF4ng c\xF3 s\u1EF1 cho ph\xE9p \u0111\u1ED3ng \xFD t\u1EEB th\xE0nh vi\xEAn.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Trong tr\u01B0\u1EDDng h\u1EE3p m\xE1y ch\u1EE7 l\u01B0u tr\u1EEF th\xF4ng tin b\u1ECB hacker t\u1EA5n c\xF4ng d\u1EABn \u0111\u1EBFn m\u1EA5t m\xE1t d\u1EEF li\u1EC7u c\xE1 nh\xE2n th\xE0nh vi\xEAn, Lookme.vn s\u1EBD c\xF3 tr\xE1ch nhi\u1EC7m th\xF4ng b\xE1o v\u1EE5 vi\u1EC7c cho c\u01A1 quan ch\u1EE9c n\u0103ng \u0111i\u1EC1u tra x\u1EED l\xFD k\u1ECBp th\u1EDDi v\xE0 th\xF4ng b\xE1o cho th\xE0nh vi\xEAn \u0111\u01B0\u1EE3c bi\u1EBFt.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'B\u1EA3o m\u1EADt tuy\u1EC7t \u0111\u1ED1i m\u1ECDi th\xF4ng tin giao d\u1ECBch tr\u1EF1c tuy\u1EBFn c\u1EE7a Th\xE0nh vi\xEAn bao g\u1ED3m th\xF4ng tin h\xF3a \u0111\u01A1n k\u1EBF to\xE1n ch\u1EE9ng t\u1EEB s\u1ED1 h\xF3a t\u1EA1i khu v\u1EF1c d\u1EEF li\u1EC7u trung t\xE2m an to\xE0n c\u1EA5p 1 c\u1EE7a Lookme.vn.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Ban qu\u1EA3n l\xFD Lookme.vn y\xEAu c\u1EA7u c\xE1c c\xE1 nh\xE2n khi \u0111\u0103ng k\xFD/mua h\xE0ng l\xE0 th\xE0nh vi\xEAn, ph\u1EA3i cung c\u1EA5p \u0111\u1EA7y \u0111\u1EE7 th\xF4ng tin c\xE1 nh\xE2n c\xF3 li\xEAn quan nh\u01B0: H\u1ECD v\xE0 t\xEAn, \u0111\u1ECBa ch\u1EC9 li\xEAn l\u1EA1c, email, s\u1ED1 ch\u1EE9ng minh nh\xE2n d\xE2n, \u0111i\u1EC7n tho\u1EA1i, s\u1ED1 t\xE0i kho\u1EA3n, s\u1ED1 th\u1EBB thanh to\xE1n \u2026., v\xE0 ch\u1ECBu tr\xE1ch nhi\u1EC7m v\u1EC1 t\xEDnh ph\xE1p l\xFD c\u1EE7a nh\u1EEFng th\xF4ng tin tr\xEAn. Ban qu\u1EA3n l\xFD Lookme.vn kh\xF4ng ch\u1ECBu tr\xE1ch nhi\u1EC7m c\u0169ng nh\u01B0 kh\xF4ng gi\u1EA3i quy\u1EBFt m\u1ECDi khi\u1EBFu n\u1EA1i c\xF3 li\xEAn quan \u0111\u1EBFn quy\u1EC1n l\u1EE3i c\u1EE7a Th\xE0nh vi\xEAn \u0111\xF3 n\u1EBFu x\xE9t th\u1EA5y t\u1EA5t c\u1EA3 th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a th\xE0nh vi\xEAn \u0111\xF3 cung c\u1EA5p khi \u0111\u0103ng k\xFD ban \u0111\u1EA7u l\xE0 kh\xF4ng ch\xEDnh x\xE1c.'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'b',
                        null,
                        _react2.default.createElement(
                          'i',
                          null,
                          'C\u01A1 ch\u1EBF ti\u1EBFp nh\u1EADn v\xE0 gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i li\xEAn quan \u0111\u1EBFn vi\u1EC7c th\xF4ng tin c\xE1 nh\xE2n kh\xE1ch h\xE0ng',
                          ' '
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\xE0nh vi\xEAn c\xF3 quy\u1EC1n g\u1EEDi khi\u1EBFu n\u1EA1i v\u1EC1 vi\u1EC7c l\u1ED9 th\xF4ng tin c\xE1c nh\xE2n cho b\xEAn th\u1EE9 3 \u0111\u1EBFn Ban qu\u1EA3n tr\u1ECB c\u1EE7a Website cung c\u1EA5p d\u1ECBch v\u1EE5 th\u01B0\u01A1ng m\u1EA1i \u0111i\u1EC7n t\u1EED Lookme.vn \u0111\u1EBFn \u0111\u1ECBa ch\u1EC9 C\xF4ng ty ho\u1EB7c qua email.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Email: hr@lookme.vn'
        ),
        _react2.default.createElement(
          'p',
          null,
          'C\xF4ng ty c\xF3 tr\xE1ch nhi\u1EC7m th\u1EF1c hi\u1EC7n c\xE1c bi\u1EC7n ph\xE1p k\u1EF9 thu\u1EADt, nghi\u1EC7p v\u1EE5 \u0111\u1EC3 x\xE1c minh c\xE1c n\u1ED9i dung \u0111\u01B0\u1EE3c ph\u1EA3n \xE1nh.',
          ' '
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\u1EDDi gian x\u1EE9 l\xFD ph\u1EA3n \xE1nh li\xEAn quan \u0111\u1EBFn th\xF4ng tin c\xE1 nh\xE2n kh\xE1ch h\xE0ng l\xE0 15 ng\xE0y.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'VII. Qu\u1EA3n l\xFD th\xF4ng tin x\u1EA5u'
          )
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'i',
                    null,
                    'Quy \u0111\u1ECBnh th\xE0nh vi\xEAn:'
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\xE0nh vi\xEAn s\u1EBD t\u1EF1 ch\u1ECBu tr\xE1ch nhi\u1EC7m v\u1EC1 b\u1EA3o m\u1EADt v\xE0 l\u01B0u gi\u1EEF m\u1ECDi ho\u1EA1t \u0111\u1ED9ng s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 d\u01B0\u1EDBi t\xEAn \u0111\u0103ng k\xFD, m\u1EADt kh\u1EA9u c\u1EE7a m\xECnh. Th\xE0nh vi\xEAn c\xF3 tr\xE1ch nhi\u1EC7m th\xF4ng b\xE1o k\u1ECBp th\u1EDDi cho Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn v\u1EC1 nh\u1EEFng h\xE0nh vi s\u1EED d\u1EE5ng tr\xE1i ph\xE9p, l\u1EA1m d\u1EE5ng, vi ph\u1EA1m b\u1EA3o m\u1EADt, l\u01B0u gi\u1EEF t\xEAn \u0111\u0103ng k\xFD v\xE0 m\u1EADt kh\u1EA9u c\u1EE7a b\xEAn th\u1EE9 ba \u0111\u1EC3 c\xF3 bi\u1EC7n ph\xE1p gi\u1EA3i quy\u1EBFt ph\xF9 h\u1EE3p.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\xE0nh vi\xEAn kh\xF4ng s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 c\u1EE7a Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn v\xE0o nh\u1EEFng m\u1EE5c \u0111\xEDch b\u1EA5t h\u1EE3p ph\xE1p, kh\xF4ng h\u1EE3p l\xFD, l\u1EEBa \u0111\u1EA3o, \u0111e do\u1EA1, th\u0103m d\xF2 th\xF4ng tin b\u1EA5t h\u1EE3p ph\xE1p, ph\xE1 ho\u1EA1i, t\u1EA1o ra v\xE0 ph\xE1t t\xE1n virus g\xE2y h\u01B0 h\u1EA1i t\u1EDBi h\u1EC7 th\u1ED1ng, c\u1EA5u h\xECnh, truy\u1EC1n t\u1EA3i th\xF4ng tin c\u1EE7a Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn hay s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 c\u1EE7a m\xECnh v\xE0o m\u1EE5c \u0111\xEDch \u0111\u1EA7u c\u01A1, l\u0169ng \u0111o\u1EA1n th\u1ECB tr\u01B0\u1EDDng t\u1EA1o nh\u1EEFng \u0111\u01A1n \u0111\u1EB7t h\xE0ng, ch\xE0o h\xE0ng gi\u1EA3, k\u1EC3 c\u1EA3 ph\u1EE5c v\u1EE5 cho vi\u1EC7c ph\xE1n \u0111o\xE1n nhu c\u1EA7u th\u1ECB tr\u01B0\u1EDDng. Trong tr\u01B0\u1EDDng h\u1EE3p vi ph\u1EA1m th\xEC th\xE0nh vi\xEAn ph\u1EA3i ch\u1ECBu tr\xE1ch nhi\u1EC7m v\u1EC1 c\xE1c h\xE0nh vi c\u1EE7a m\xECnh tr\u01B0\u1EDBc ph\xE1p lu\u1EADt.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\xE0nh vi\xEAn kh\xF4ng \u0111\u01B0\u1EE3c thay \u0111\u1ED5i, ch\u1EC9nh s\u1EEDa, g\xE1n gh\xE9p, copy, truy\u1EC1n b\xE1, ph\xE2n ph\u1ED1i, cung c\u1EA5p v\xE0 t\u1EA1o nh\u1EEFng c\xF4ng c\u1EE5 t\u01B0\u01A1ng t\u1EF1 c\u1EE7a d\u1ECBch v\u1EE5 do Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn cung c\u1EA5p cho m\u1ED9t b\xEAn th\u1EE9 ba n\u1EBFu kh\xF4ng \u0111\u01B0\u1EE3c s\u1EF1 \u0111\u1ED3ng \xFD c\u1EE7a Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn trong b\u1EA3n Quy ch\u1EBF n\xE0y.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\xE0nh vi\xEAn kh\xF4ng \u0111\u01B0\u1EE3c h\xE0nh \u0111\u1ED9ng g\xE2y m\u1EA5t uy t\xEDn c\u1EE7a Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn d\u01B0\u1EDBi m\u1ECDi h\xECnh th\u1EE9c nh\u01B0 g\xE2y m\u1EA5t \u0111o\xE0n k\u1EBFt gi\u1EEFa c\xE1c th\xE0nh vi\xEAn b\u1EB1ng c\xE1ch s\u1EED d\u1EE5ng t\xEAn \u0111\u0103ng k\xFD th\u1EE9 hai, th\xF4ng qua m\u1ED9t b\xEAn th\u1EE9 ba ho\u1EB7c tuy\xEAn truy\u1EC1n, ph\u1ED5 bi\u1EBFn nh\u1EEFng th\xF4ng tin kh\xF4ng c\xF3 l\u1EE3i cho uy t\xEDn c\u1EE7a Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn.'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              _react2.default.createElement(
                'i',
                null,
                'H\xE0nh vi c\u1EA5m trong ho\u1EA1t \u0111\u1ED9ng \u0111\u0103ng t\u1EA3i tin \u0111\u1EC3 gi\u1EDBi thi\u1EC7u, qu\u1EA3ng c\xE1o d\u1ECBch v\u1EE5 tr\xEAn'
              )
            ),
            _react2.default.createElement(
              'b',
              null,
              _react2.default.createElement(
                'i',
                null,
                'Lookme.vn'
              )
            )
          )
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            'Qu\u1EA3ng c\xE1o thi\u1EBFu th\u1EA9m m\u1EF9, tr\xE1i v\u1EDBi truy\u1EC1n th\u1ED1ng l\u1ECBch s\u1EED, v\u0103n h\xF3a, \u0111\u1EA1o \u0111\u1EE9c, thu\u1EA7n phong m\u1EF9 t\u1EE5c Vi\u1EC7t Nam.'
          ),
          _react2.default.createElement(
            'li',
            null,
            'Qu\u1EA3ng c\xE1o x\xFAc ph\u1EA1m uy t\xEDn, danh d\u1EF1, nh\xE2n ph\u1EA9m c\u1EE7a t\u1ED5 ch\u1EE9c, c\xE1 nh\xE2n.'
          ),
          _react2.default.createElement(
            'li',
            null,
            'Qu\u1EA3ng c\xE1o c\xF3 s\u1EED d\u1EE5ng h\xECnh \u1EA3nh, l\u1EDDi n\xF3i, ch\u1EEF vi\u1EBFt c\u1EE7a c\xE1 nh\xE2n khi ch\u01B0a \u0111\u01B0\u1EE3c c\xE1 nh\xE2n \u0111\xF3 \u0111\u1ED3ng \xFD, tr\u1EEB tr\u01B0\u1EDDng h\u1EE3p \u0111\u01B0\u1EE3c ph\xE1p lu\u1EADt cho ph\xE9p.'
          ),
          _react2.default.createElement(
            'li',
            null,
            'Qu\u1EA3ng c\xE1o kh\xF4ng \u0111\xFAng ho\u1EB7c g\xE2y nh\u1EA7m l\u1EABn v\u1EC1 kh\u1EA3 n\u0103ng kinh doanh, kh\u1EA3 n\u0103ng cung c\u1EA5p s\u1EA3n ph\u1EA9m, h\xE0ng h\xF3a, d\u1ECBch v\u1EE5 c\u1EE7a t\u1ED5 ch\u1EE9c, c\xE1 nh\xE2n kinh doanh s\u1EA3n ph\u1EA9m, h\xE0ng h\xF3a, d\u1ECBch v\u1EE5; v\u1EC1 s\u1ED1 l\u01B0\u1EE3ng, ch\u1EA5t l\u01B0\u1EE3ng, gi\xE1, c\xF4ng d\u1EE5ng, ki\u1EC3u d\xE1ng, bao b\xEC, nh\xE3n hi\u1EC7u, xu\u1EA5t x\u1EE9, ch\u1EE7ng lo\u1EA1i, ph\u01B0\u01A1ng th\u1EE9c ph\u1EE5c v\u1EE5, th\u1EDDi h\u1EA1n b\u1EA3o h\xE0nh c\u1EE7a s\u1EA3n ph\u1EA9m, h\xE0ng ho\xE1, d\u1ECBch v\u1EE5 \u0111\xE3 \u0111\u0103ng k\xFD ho\u1EB7c \u0111\xE3 \u0111\u01B0\u1EE3c c\xF4ng b\u1ED1.'
          ),
          _react2.default.createElement(
            'li',
            null,
            'Qu\u1EA3ng c\xE1o b\u1EB1ng vi\u1EC7c s\u1EED d\u1EE5ng ph\u01B0\u01A1ng ph\xE1p so s\xE1nh tr\u1EF1c ti\u1EBFp v\u1EC1 gi\xE1 c\u1EA3, ch\u1EA5t l\u01B0\u1EE3ng, hi\u1EC7u qu\u1EA3 s\u1EED d\u1EE5ng s\u1EA3n ph\u1EA9m, h\xE0ng h\xF3a, d\u1ECBch v\u1EE5 c\u1EE7a m\xECnh v\u1EDBi gi\xE1 c\u1EA3, ch\u1EA5t l\u01B0\u1EE3ng, hi\u1EC7u qu\u1EA3 s\u1EED d\u1EE5ng s\u1EA3n ph\u1EA9m, h\xE0ng h\xF3a, d\u1ECBch v\u1EE5 c\xF9ng lo\u1EA1i c\u1EE7a t\u1ED5 ch\u1EE9c, c\xE1 nh\xE2n kh\xE1c.'
          ),
          _react2.default.createElement(
            'li',
            null,
            'Qu\u1EA3ng c\xE1o c\xF3 n\u1ED9i dung c\u1EA1nh tranh kh\xF4ng l\xE0nh m\u1EA1nh theo quy \u0111\u1ECBnh c\u1EE7a ph\xE1p lu\u1EADt v\u1EC1 c\u1EA1nh tranh.'
          ),
          _react2.default.createElement(
            'li',
            null,
            'Qu\u1EA3ng c\xE1o vi ph\u1EA1m ph\xE1p lu\u1EADt v\u1EC1 s\u1EDF h\u1EEFu tr\xED tu\u1EC7.'
          )
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              _react2.default.createElement(
                'i',
                null,
                'C\u01A1 ch\u1EBF r\xE0 so\xE1t, ki\u1EC3m so\xE1t th\xF4ng tin v\u1EC1 d\u1ECBch v\u1EE5 c\u1EE7a Ban qu\u1EA3n l\xFD Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T \u0111\u1ED1i v\u1EDBi d\u1ECBch v\u1EE5 \u0111\u0103ng t\u1EA3i tr\xEAn website:',
                ' '
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Sau khi nh\xE0 cung c\u1EA5p \u0111\u0103ng th\xF4ng tin l\xEAn gian h\xE0ng s\u1EBD \u0111\u01B0\u1EE3c hi\u1EC7n th\u1ECB ngay. Nh\u01B0ng c\xE1c th\xF4ng tin n\xE0y s\u1EBD \u0111\u01B0\u1EE3c b\u1ED9 ph\u1EADn bi\xEAn t\u1EADp qu\u1EA3n l\xFD n\u1ED9i dung Lookme.vn ki\u1EC3m so\xE1t v\xE0 x\xE9t duy\u1EC7t ch\u1EB7t ch\u1EBD h\xE0ng gi\u1EDD li\xEAn t\u1EE5c h\xE0ng ng\xE0y.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Lookme.vn s\u1EBD to\xE0n quy\u1EC1n lo\u1EA1i b\u1ECF c\xE1c th\xF4ng tin c\u1EE7a nh\xE0 cung c\u1EA5p n\u1EBFu nh\u01B0 th\xF4ng tin vi ph\u1EA1m quy ch\u1EBF \u0111\u0103ng tin.',
          ' '
        ),
        _react2.default.createElement(
          'p',
          null,
          'Lookme.vn gi\u1EEF quy\u1EC1n quy\u1EBFt \u0111\u1ECBnh v\u1EC1 vi\u1EC7c l\u01B0u gi\u1EEF hay lo\u1EA1i b\u1ECF tin \u0111\xE3 \u0111\u0103ng tr\xEAn trang web n\xE0y m\xE0 kh\xF4ng c\u1EA7n b\xE1o tr\u01B0\u1EDBc.',
          ' '
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'b',
            null,
            'VIII Tr\xE1ch nhi\u1EC7m trong tr\u01B0\u1EDDng h\u1EE3p ph\xE1t sinh l\u1ED7i k\u1EF9 thu\u1EADt'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn cam k\u1EBFt n\u1ED7 l\u1EF1c \u0111\u1EA3m b\u1EA3o s\u1EF1 an to\xE0n v\xE0 \u1ED5n \u0111\u1ECBnh c\u1EE7a to\xE0n b\u1ED9 h\u1EC7 th\u1ED1ng k\u1EF9 thu\u1EADt. Tuy nhi\xEAn, trong tr\u01B0\u1EDDng h\u1EE3p x\u1EA3y ra s\u1EF1 c\u1ED1 do l\u1ED7i c\u1EE7a Lookme.vn, Lookme.vn s\u1EBD ngay l\u1EADp t\u1EE9c \xE1p d\u1EE5ng c\xE1c bi\u1EC7n ph\xE1p \u0111\u1EC3 \u0111\u1EA3m b\u1EA3o quy\u1EC1n l\u1EE3i cho ',
          _react2.default.createElement(
            'b',
            null,
            'Kh\xE1ch h\xE0ng'
          ),
          '.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Khi th\u1EF1c hi\u1EC7n c\xE1c giao d\u1ECBch tr\xEAn S\xE0n, b\u1EAFt bu\u1ED9c c\xE1c th\xE0nh vi\xEAn ph\u1EA3i th\u1EF1c hi\u1EC7n \u0111\xFAng theo c\xE1c quy tr\xECnh h\u01B0\u1EDBng d\u1EABn.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Ban qu\u1EA3n l\xFD S\xE0n giao d\u1ECBch Lookme.vn cam k\u1EBFt cung c\u1EA5p ch\u1EA5t l\u01B0\u1EE3ng d\u1ECBch v\u1EE5 t\u1ED1t nh\u1EA5t cho c\xE1c th\xE0nh vi\xEAn tham gia giao d\u1ECBch. Tr\u01B0\u1EDDng h\u1EE3p ph\xE1t sinh l\u1ED7i k\u1EF9 thu\u1EADt, l\u1ED7i ph\u1EA7n m\u1EC1m ho\u1EB7c c\xE1c l\u1ED7i kh\xE1ch quan kh\xE1c d\u1EABn \u0111\u1EBFn Th\xE0nh vi\xEAn kh\xF4ng th\u1EC3 tham gia giao d\u1ECBch \u0111\u01B0\u1EE3c th\xEC c\xE1c Th\xE0nh vi\xEAn th\xF4ng b\xE1o cho Ban qu\u1EA3n l\xFD Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T qua \u0111\u1ECBa ch\u1EC9 email: hr@lookme.vn ch\xFAng t\xF4i s\u1EBD kh\u1EAFc ph\u1EE5c l\u1ED7i trong th\u1EDDi gian s\u1EDBm nh\u1EA5t, t\u1EA1o \u0111i\u1EC1u ki\u1EC7n cho c\xE1c Th\xE0nh vi\xEAn tham gia Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Tuy nhi\xEAn, Ban qu\u1EA3n l\xFD Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn s\u1EBD kh\xF4ng ch\u1ECBu tr\xE1ch nhi\u1EC7m gi\u1EA3i quy\u1EBFt trong tr\u01B0\u1EDDng h\u1EE3p th\xF4ng b\xE1o c\u1EE7a c\xE1c th\xE0nh vi\xEAn kh\xF4ng \u0111\u1EBFn \u0111\u01B0\u1EE3c Ban qu\u1EA3n l\xFD, ph\xE1t sinh t\u1EEB l\u1ED7i k\u1EF9 thu\u1EADt, l\u1ED7i \u0111\u01B0\u1EDDng truy\u1EC1n, ph\u1EA7n m\u1EC1m ho\u1EB7c c\xE1c l\u1ED7i kh\xE1c kh\xF4ng do Ban qu\u1EA3n l\xFD g\xE2y ra.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'IX. Quy\u1EC1n V\xE0 Tr\xE1ch Nhi\u1EC7m C\u1EE7a Ban Qu\u1EA3n L\xFD Website TM\u0110T Lookme.vn'
          )
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    _react2.default.createElement(
                      'i',
                      null,
                      'Quy\u1EC1n c\u1EE7a B\u1EA3n qu\u1EA3n l\xFD Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn'
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn s\u1EBD ti\u1EBFn h\xE0nh cung c\u1EA5p c\xE1c d\u1ECBch v\u1EE5 cho nh\u1EEFng th\xE0nh vi\xEAn tham gia sau khi \u0111\xE3 ho\xE0n th\xE0nh c\xE1c th\u1EE7 t\u1EE5c v\xE0 c\xE1c \u0111i\u1EC1u ki\u1EC7n b\u1EAFt bu\u1ED9c Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn n\xEAu ra.',
          ' '
        ),
        _react2.default.createElement(
          'p',
          null,
          'C\xF3 quy\u1EC1n y\xEAu c\u1EA7u \u0110\u1ED1i t\xE1c cung c\u1EA5p th\xF4ng tin v\xE0 y\xEAu c\u1EA7u h\u1EE3p t\xE1c t\u1EEB ph\xEDa \u0110\u1ED1i t\xE1c trong qu\xE1 tr\xECnh th\u1EF1c hi\u1EC7n c\xF4ng vi\u1EC7c c\u1EE7a m\xECnh.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Trong tr\u01B0\u1EDDng h\u1EE3p c\xF3 c\u01A1 s\u1EDF \u0111\u1EC3 ch\u1EE9ng minh th\xE0nh vi\xEAn cung c\u1EA5p th\xF4ng tin cho Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn kh\xF4ng ch\xEDnh x\xE1c, sai l\u1EC7ch, kh\xF4ng \u0111\u1EA7y \u0111\u1EE7 ho\u1EB7c vi ph\u1EA1m ph\xE1p lu\u1EADt hay thu\u1EA7n phong m\u1EF9 t\u1EE5c Vi\u1EC7t Nam th\xEC Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn c\xF3 quy\u1EC1n t\u1EEB ch\u1ED1i, t\u1EA1m ng\u1EEBng ho\u1EB7c ch\u1EA5m d\u1EE9t quy\u1EC1n s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 c\u1EE7a th\xE0nh vi\xEAn.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn c\xF3 th\u1EC3 ch\u1EA5m d\u1EE9t quy\u1EC1n th\xE0nh vi\xEAn v\xE0 quy\u1EC1n s\u1EED d\u1EE5ng m\u1ED9t ho\u1EB7c t\u1EA5t c\u1EA3 c\xE1c d\u1ECBch v\u1EE5 c\u1EE7a th\xE0nh vi\xEAn v\xE0 s\u1EBD th\xF4ng b\xE1o cho th\xE0nh vi\xEAn trong th\u1EDDi h\u1EA1n \xEDt nh\u1EA5t l\xE0 m\u1ED9t (01) th\xE1ng trong tr\u01B0\u1EDDng h\u1EE3p th\xE0nh vi\xEAn vi ph\u1EA1m c\xE1c Quy ch\u1EBF c\u1EE7a Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn ho\u1EB7c c\xF3 nh\u1EEFng h\xE0nh vi \u1EA3nh h\u01B0\u1EDFng \u0111\u1EBFn ho\u1EA1t \u0111\u1ED9ng kinh doanh tr\xEAn Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn .'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn c\xF3 th\u1EC3 ch\u1EA5m d\u1EE9t ngay quy\u1EC1n s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 v\xE0 quy\u1EC1n th\xE0nh vi\xEAn c\u1EE7a th\xE0nh vi\xEAn n\u1EBFu Lookme.vn ph\xE1t hi\u1EC7n th\xE0nh vi\xEAn \u0111\xE3 ph\xE1 s\u1EA3n, b\u1ECB k\u1EBFt \xE1n ho\u1EB7c \u0111ang trong th\u1EDDi gian th\u1EE5 \xE1n, trong tr\u01B0\u1EDDng h\u1EE3p th\xE0nh vi\xEAn ti\u1EBFp t\u1EE5c ho\u1EA1t \u0111\u1ED9ng c\xF3 th\u1EC3 g\xE2y cho Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn tr\xE1ch nhi\u1EC7m ph\xE1p l\xFD, c\xF3 nh\u1EEFng ho\u1EA1t \u0111\u1ED9ng l\u1EEBa \u0111\u1EA3o, gi\u1EA3 m\u1EA1o, g\xE2y r\u1ED1i lo\u1EA1n th\u1ECB tr\u01B0\u1EDDng, g\xE2y m\u1EA5t \u0111o\xE0n k\u1EBFt \u0111\u1ED1i v\u1EDBi c\xE1c th\xE0nh vi\xEAn kh\xE1c c\u1EE7a Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn , ho\u1EA1t \u0111\u1ED9ng vi ph\u1EA1m ph\xE1p lu\u1EADt hi\u1EC7n h\xE0nh c\u1EE7a Vi\u1EC7t Nam. Trong tr\u01B0\u1EDDng h\u1EE3p ch\u1EA5m d\u1EE9t quy\u1EC1n th\xE0nh vi\xEAn v\xE0 quy\u1EC1n s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 th\xEC t\u1EA5t c\u1EA3 c\xE1c ch\u1EE9ng nh\u1EADn, c\xE1c quy\u1EC1n c\u1EE7a th\xE0nh vi\xEAn \u0111\u01B0\u1EE3c c\u1EA5p s\u1EBD m\u1EB7c nhi\xEAn h\u1EBFt gi\xE1 tr\u1ECB v\xE0 b\u1ECB ch\u1EA5m d\u1EE9t.',
          ' '
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u0110\u1ED1i t\xE1c c\u1EA5p cho Lookme.vn quy\u1EC1n s\u1EED d\u1EE5ng t\xEAn, logo, th\xF4ng tin li\xEAn quan v\u1EC1 \u0110\u1ED1i t\xE1c tr\xEAn c\xE1c t\xE0i li\u1EC7u ti\u1EBFp th\u1ECB \u0111\u1EC3 \u0110\u1ED1i t\xE1c \u0111\u01B0\u1EE3c xem nh\u01B0 m\u1ED9t ngu\u1ED3n tham kh\u1EA3o ph\u1EE5c v\u1EE5 cho c\xF4ng vi\u1EC7c/li\xEAn doanh m\xE0 Lookme.vn cung c\u1EA5p, v\xE0 \u0111\u01B0\u1EE3c quy\u1EC1n xu\u1EA5t b\u1EA3n v\xE0 c\xF4ng b\xE1o v\u1EC1 to\xE0n b\u1ED9 ti\u1EBFn tri\u1EC3n v\xE0 c\xF4ng vi\u1EC7c h\u1EE3p t\xE1c trong H\u1EE3p \u0111\u1ED3ng, mi\u1EC5n l\xE0 kh\xF4ng ti\u1EBFt l\u1ED9 b\xED m\u1EADt th\u01B0\u01A1ng m\u1EA1i, th\xF4ng tin kinh doanh m\xE0 kh\xF4ng c\xF3 s\u1EF1 \u0111\u1ED3ng \xFD c\u1EE7a \u0111\u1ED1i t\xE1c.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn gi\u1EEF b\u1EA3n quy\u1EC1n s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 v\xE0 c\xE1c n\u1ED9i dung tr\xEAn Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn theo c\xE1c quy d\u1ECBnh ph\xE1p lu\u1EADt v\u1EC1 b\u1EA3o h\u1ED9 s\u1EDF h\u1EEFu tr\xED tu\u1EC7 t\u1EA1i Vi\u1EC7t Nam. T\u1EA5t c\u1EA3 c\xE1c bi\u1EC3u t\u01B0\u1EE3ng, n\u1ED9i dung theo c\xE1c ng\xF4n ng\u1EEF kh\xE1c nhau \u0111\u1EC1u thu\u1ED9c quy\u1EC1n s\u1EDF h\u1EEFu c\u1EE7a Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn . Nghi\xEAm c\u1EA5m m\u1ECDi h\xE0nh vi sao ch\xE9p, s\u1EED d\u1EE5ng v\xE0 ph\u1ED5 bi\u1EBFn b\u1EA5t h\u1EE3p ph\xE1p c\xE1c quy\u1EC1n s\u1EDF h\u1EEFu tr\xEAn.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn gi\u1EEF quy\u1EC1n \u0111\u01B0\u1EE3c thay \u0111\u1ED5i b\u1EA3ng, bi\u1EC3u gi\xE1 d\u1ECBch v\u1EE5 v\xE0 ph\u01B0\u01A1ng th\u1EE9c thanh to\xE1n trong th\u1EDDi gian cung c\u1EA5p d\u1ECBch v\u1EE5 cho th\xE0nh vi\xEAn theo nhu c\u1EA7u v\xE0 \u0111i\u1EC1u ki\u1EC7n kh\u1EA3 n\u0103ng c\u1EE7a Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn v\xE0 s\u1EBD b\xE1o tr\u01B0\u1EDBc cho th\xE0nh vi\xEAn th\u1EDDi h\u1EA1n l\xE0 m\u1ED9t (01) th\xE1ng.',
          ' '
        ),
        _react2.default.createElement(
          'p',
          null,
          'C\xF3 quy\u1EC1n \u0111\u01B0\u1EE3c thanh to\xE1n \u0111\u1EA7y \u0111\u1EE7 v\xE0 \u0111\xFAng h\u1EA1n theo quy \u0111\u1ECBnh c\u1EE7a h\u1EE3p \u0111\u1ED3ng. C\xF3 quy\u1EC1n y\xEAu c\u1EA7u kh\u1EAFc ph\u1EE5c v\xE0 b\u1ED3i th\u01B0\u1EDDng trong tr\u01B0\u1EDDng h\u1EE3p \u0110\u1ED1i t\xE1c vi ph\u1EA1m b\u1EA5t c\u1EE9 ngh\u0129a v\u1EE5 n\xE0o theo H\u1EE3p \u0111\u1ED3ng v\xE0/ho\u1EB7c g\xE2y thi\u1EC7t h\u1EA1i cho Lookme.vn .'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Lookme.vn c\xF3 quy\u1EC1n th\u1EF1c hi\u1EC7n t\u1EA5t c\u1EA3 c\xE1c ho\u1EA1t \u0111\u1ED9ng ti\u1EBFp th\u1ECB nh\u01B0 t\u1EDD r\u01A1i, \xE1p ph\xEDch, bi\u1EC3u ng\u1EEF v\xE0 c\xE1c chi\u1EBFn d\u1ECBch x\xFAc ti\u1EBFn th\u01B0\u01A1ng m\u1EA1i cho c\xE1c website, \u1EE9ng d\u1EE5ng c\u1EE7a Lookme.vn t\u1EA1i \u0111\u1ECBa \u0111i\u1EC3m \u0111ang kinh doanh c\u1EE7a \u0111\u1ED1i t\xE1c; c\u0169ng nh\u01B0 s\u1EED d\u1EE5ng t\xEAn \u0110\u1ED1i t\xE1c trong c\xE1c ho\u1EA1t \u0111\u1ED9ng ti\u1EBFp th\u1ECB.'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    _react2.default.createElement(
                      'i',
                      null,
                      'Tr\xE1ch nhi\u1EC7m c\u1EE7a B\u1EA3n qu\u1EA3n l\xFD Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn'
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn c\xF3 tr\xE1ch nhi\u1EC7m x\xE2y d\u1EF1ng, th\u1EF1c hi\u1EC7n \u201Cc\u01A1 ch\u1EBF ki\u1EC3m tra, gi\xE1m s\xE1t \u0111\u1EC3 \u0111\u1EA3m b\u1EA3o vi\u1EC7c cung c\u1EA5p th\xF4ng tin c\u1EE7a Nh\xE0 cung c\u1EA5p tr\xEAn website cung c\u1EA5p d\u1ECBch v\u1EE5 th\u01B0\u01A1ng m\u1EA1i \u0111i\u1EC7n t\u1EED \u0111\u01B0\u1EE3c th\u1EF1c hi\u1EC7n ch\xEDnh x\xE1c \u0111\u1EA7y \u0111\u1EE7\u201D theo quy \u0111\u1ECBnh t\u1EA1i Kho\u1EA3n 4 \u0110i\u1EC1u 36 Ngh\u1ECB \u0111\u1ECBnh 52/2013/N\u0110-CP. B\u1EA3o \u0111\u1EA3m Website s\u1EBD \u0111\u01B0\u1EE3c \u0111i\u1EC1u h\xE0nh, ho\u1EA1t \u0111\u1ED9ng v\xE0 duy tr\xEC m\u1ED9t c\xE1ch ph\xF9 h\u1EE3p c\xE1c ti\xEAu chu\u1EA9n ch\u1EA5t l\u01B0\u1EE3ng qu\u1ED1c gia c\u1EE7a Vi\u1EC7t Nam m\u1ED9t c\xE1ch tr\u01A1n tru v\xE0 \u0111\xE1p \u1EE9ng d\u1ECBch v\u1EE5 cung c\u1EA5p theo c\xE1c \u0111i\u1EC1u kho\u1EA3n c\u1EE7a H\u1EE3p \u0111\u1ED3ng.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn ch\u1ECBu tr\xE1ch nhi\u1EC7m x\xE2y d\u1EF1ng m\u1ED9t s\u1ED1 c\xF4ng vi\u1EC7c ch\xEDnh nh\u01B0: nghi\xEAn c\u1EE9u, thi\u1EBFt k\u1EBF, mua s\u1EAFm c\xE1c thi\u1EBFt b\u1ECB ph\u1EA7n c\u1EE9ng v\xE0 ph\u1EA7n m\u1EC1m, k\u1EBFt n\u1ED1i Internet, x\xE2y d\u1EF1ng ch\xEDnh s\xE1ch ph\u1EE5c v\u1EE5 cho ho\u1EA1t \u0111\u1ED9ng Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn trong \u0111i\u1EC1u ki\u1EC7n v\xE0 ph\u1EA1m vi cho ph\xE9p. Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn s\u1EBD ti\u1EBFn h\xE0nh tri\u1EC3n khai v\xE0 h\u1EE3p t\xE1c v\u1EDBi c\xE1c \u0111\u1ED1i t\xE1c trong vi\u1EC7c x\xE2y d\u1EF1ng h\u1EC7 th\u1ED1ng c\xE1c d\u1ECBch v\u1EE5, c\xE1c c\xF4ng c\u1EE5 ti\u1EC7n \xEDch ph\u1EE5c v\u1EE5 cho vi\u1EC7c giao d\u1ECBch c\u1EE7a c\xE1c th\xE0nh vi\xEAn tham gia v\xE0 ng\u01B0\u1EDDi s\u1EED d\u1EE5ng tr\xEAn Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn .'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn c\xF3 tr\xE1ch nhi\u1EC7m \u0111\u1EE9ng ra l\xE0m trung gian trong vi\u1EC7c h\xF2a gi\u1EA3i n\u1EBFu x\u1EA3y ra tranh ch\u1EA5p gi\u1EEFa ng\u01B0\u1EDDi cung c\u1EA5p d\u1ECBch v\u1EE5 v\xE0 ng\u01B0\u1EDDi \u0111\u1EB7t d\u1ECBch v\u1EE5. S\xE0n s\u1EBD ti\u1EBFp nh\u1EADn th\xF4ng tin ph\u1EA3n \u1EA3nh, khi\u1EBFu n\u1EA1i t\u1EEB ng\u01B0\u1EDDi ch\u01A1i v\xE0 ki\u1EC3m tra n\u1ED9i dung ph\u1EA3n \xE1nh, khi\u1EBFu n\u1EA1i \u0111\xF3. N\u1EBFu x\xE9t th\u1EA5y nh\u1EEFng ph\u1EA3n \xE1nh \u0111\xF3 l\xE0 \u0111\xFAng S\xE0n s\u1EBD y\xEAu c\u1EA7u nh\xE0 cung c\u1EA5p ph\u1EA3i gi\u1EA3i tr\xECnh v\u1EC1 nh\u1EEFng th\xF4ng tin \u0111\xF3. Tu\u1EF3 theo m\u1EE9c \u0111\u1ED9 sai ph\u1EA1m Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn s\u1EBD c\xF3 ph\u01B0\u1EDBng \xE1n gi\u1EA3i quy\u1EBFt y\xEAu c\u1EA7u b\xEAn cung c\u1EA5p d\u1ECBch v\u1EE5 \u0111\u1EC1n b\xF9 cho ng\u01B0\u1EDDi ch\u01A1i, s\u1EBD kh\xF3a t\xE0i kho\xE0n th\xE0nh vi\xEAn b\xEAn cung c\u1EA5p d\u1ECBch v\u1EE5.',
          ' '
        ),
        _react2.default.createElement(
          'p',
          null,
          'Lo\u1EA1i b\u1ECF kh\u1ECFi website Lookme.vn nh\u1EEFng th\xF4ng tin d\u1ECBch v\u1EE5 vi ph\u1EA1m quy\u1EC1n s\u1EDF h\u1EEFu tr\xED tu\u1EC7 v\xE0 c\xE1c d\u1ECBch v\u1EE5 vi ph\u1EA1m ph\xE1p lu\u1EADt kh\xE1c khi ph\xE1t hi\u1EC7n ho\u1EB7c nh\u1EADn \u0111\u01B0\u1EE3c ph\u1EA3n \xE1nh c\xF3 c\u0103n c\u1EE9 x\xE1c th\u1EF1c v\u1EC1 nh\u1EEFng th\xF4ng tin n\xE0y.',
          ' '
        ),
        _react2.default.createElement(
          'p',
          null,
          'Ng\u0103n ch\u1EB7n v\xE0 lo\u1EA1i b\u1ECF kh\u1ECFi Lookme.vn nh\u1EEFng th\xF4ng tin b\xE1n h\xE0ng, d\u1ECBch v\u1EE5 thu\u1ED9c danh m\u1EE5c d\u1ECBch v\u1EE5, d\u1ECBch v\u1EE5 c\u1EA5m kinh doanh theo quy \u0111\u1ECBnh c\u1EE7a Ph\xE1p lu\u1EADt v\xE0 d\u1ECBch v\u1EE5 h\u1EA1n ch\u1EBF kinh doanh ho\u1EB7c d\u1ECBch v\u1EE5, d\u1ECBch v\u1EE5 kinh doanh c\xF3 \u0111i\u1EC1u ki\u1EC7n tr\xEAn Lookme.vn ;',
          ' '
        ),
        _react2.default.createElement(
          'p',
          null,
          'Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn s\u1EBD c\u1ED1 g\u1EAFng \u0111\u1EBFn m\u1EE9c cao nh\u1EA5t trong ph\u1EA1m vi v\xE0 \u0111i\u1EC1u ki\u1EC7n c\xF3 th\u1EC3 \u0111\u1EC3 duy tr\xEC ho\u1EA1t \u0111\u1ED9ng b\xECnh th\u01B0\u1EDDng c\u1EE7a Lookme.vn v\xE0 kh\u1EAFc ph\u1EE5c theo c\xE1c \u0111i\u1EC1u kho\u1EA3n v\xE0 \u0111i\u1EC1u ki\u1EC7n c\u1EE7a H\u1EE3p \u0111\u1ED3ng. Tuy nhi\xEAn n\u1EBFu nh\u1EEFng s\u1EF1 c\u1ED1 tr\xEAn x\u1EA3y ra n\u1EB1m ngo\xE0i kh\u1EA3 n\u0103ng ki\u1EC3m so\xE1t, l\xE0 nh\u1EEFng tr\u01B0\u1EDDng h\u1EE3p b\u1EA5t kh\u1EA3 kh\xE1ng m\xE0 g\xE2y thi\u1EC7t h\u1EA1i cho th\xE0nh vi\xEAn th\xEC Lookme.vn kh\xF4ng ph\u1EA3i ch\u1ECBu tr\xE1ch nhi\u1EC7m li\xEAn \u0111\u1EDBi.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Lookme.vn s\u1EBD cung c\u1EA5p h\xF3a \u0111\u01A1n GTGT cho kho\u1EA3n hoa h\u1ED3ng \u0111\u01B0\u1EE3c thanh to\xE1n \u0111\u1EA7y \u0111\u1EE7 cho \u0110\u1ED1i t\xE1c k\xE8m v\u1EDBi b\xE1o c\xE1o qu\u1EA3n l\xFD h\xE0ng th\xE1ng c\u1EE7a Lookme.vn n\u1EBFu \u0111\u1ED1i t\xE1c y\xEAu c\u1EA7u. H\xF3a \u0111\u01A1n GTGT ph\u1EA3i \u0111\u01B0\u1EE3c cung c\u1EA5p trong v\xF2ng 5 ng\xE0y l\xE0m vi\u1EC7c k\u1EC3 t\u1EEB ng\xE0y \u0111\xE1p \u1EE9ng t\u1EA5t c\u1EA3 c\xE1c \u0111i\u1EC1u ki\u1EC7n tr\xEAn.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Ph\u1ED1i h\u1EE3p v\u1EDBi Nh\xE0 cung c\u1EA5p gi\u1EA3i quy\u1EBFt nh\u1EEFng v\u1EA5n \u0111\u1EC1 tranh ch\u1EA5p gi\u1EEFa th\xE0nh vi\xEAn v\u1EDBi \u0111\u1ED1i t\xE1c v\u1EC1 nh\u1EEFng khi\u1EBFu n\u1EA1i trong qu\xE1 tr\xECnh cung c\u1EA5p d\u1ECBch v\u1EE5 di\u1EC5n ra qua Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn . Ho\xE0n tr\u1EA3 ph\xED d\u1ECBch v\u1EE5 v\xE0 \u0111\u1EA3m b\u1EA3o quy\u1EC1n l\u1EE3i cho Kh\xE1ch h\xE0ng b\u1EB1ng c\xE1ch ho\xE0n tr\u1EA3 ph\xED/ \u0111\u1ED5i tr\u1EA3 d\u1ECBch v\u1EE5 t\u01B0\u01A1ng x\u1EE9ng n\u1EBFu x\xE1c \u0111\u1ECBnh l\u1ED7i thu\u1ED9c v\u1EC1 Nh\xE0 cung c\u1EA5p. Lookme.vn s\u1EBD y\xEAu c\u1EA7u nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 c\xF3 ngh\u0129a v\u1EE5 ph\u1EA3i b\u1ED3i th\u01B0\u1EDDng nh\u1EEFng thi\u1EC7t h\u1EA1i c\u1EE7a th\xE0nh vi\xEAn khi l\u1ED7i \u0111\u01B0\u1EE3c x\xE1c \u0111\u1ECBnh thu\u1ED9c v\u1EC1 Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5. Lookme.vn cam k\u1EBFt c\xE1c k\xEAnh h\u1ED7 tr\u1EE3 ch\xEDnh th\u1EE9c s\u1EBD \u0111\u01B0\u1EE3c \xE1p d\u1EE5ng trong v\xF2ng 72 gi\u1EDD t\u1EEB khi nh\u1EADn \u0111\u01B0\u1EE3c \u0111\u01A1n h\xE0ng.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Lookme.vn s\u1EBD kh\xF4ng chia s\u1EBB d\u1EEF li\u1EC7u c\xE1 nh\xE2n c\u1EE7a kh\xE1ch h\xE0ng cho \u0111\u1ED1i t\xE1c nhi\u1EC1u h\u01A1n c\xE1c th\xF4ng tin c\u1EA7n thi\u1EBFt nh\u01B0 h\u1ECD, t\xEAn, h\xECnh \u0111\u1EA1i di\u1EC7n, s\u1ED1 \u0111i\u1EC7n tho\u1EA1i v\xE0 s\u1ED1 li\u1EC7u th\u1ED1ng k\xEA kh\xE1c. Trong tr\u01B0\u1EDDng h\u1EE3p x\u1EA3y ra b\u1EA5t k\u1EF3 v\u1EA5n \u0111\u1EC1 g\xEC v\u1EDBi kh\xE1ch h\xE0ng, c\xE1c b\xEAn hi\u1EC3u r\u1EB1ng Lookme.vn kh\xF4ng c\xF3 tr\xE1ch nhi\u1EC7m th\u1EA9m tra kh\xE1ch h\xE0ng b\u1EDFi website l\xE0 giao di\u1EC7n th\xE2n thi\u1EC7n v\u1EDBi ng\u01B0\u1EDDi d\xF9ng d\u1EC5 d\xE0ng truy c\u1EADp, thu h\xFAt \u0111\xF4ng \u0111\u1EA3o c\u1ED9ng \u0111\u1ED3ng c\xF9ng quan t\xE2m. Tuy nhi\xEAn Lookme.vn s\u1EBD n\u1ED7 l\u1EF1c h\u1EE3p l\xFD \u0111\u1EC3 h\u1EE3p t\xE1c v\u1EDBi \u0111\u1ED1i t\xE1c v\xE0 c\xE1c c\u01A1 quan c\xF3 th\u1EA9m quy\u1EC1n trong tr\u01B0\u1EDDng h\u1EE3p ph\xE1p lu\u1EADt Vi\u1EC7t Nam c\xF3 quy \u0111\u1ECBnh.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          'X. Quy\u1EC1n v\xE0 tr\xE1ch nhi\u1EC7m c\u1EE7a Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 tr\xEAn Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T ',
          _react2.default.createElement(
            'i',
            null,
            'Lookme.vn'
          )
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                      'ul',
                      null,
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(
                          'i',
                          null,
                          'Quy\u1EC1n c\u1EE7a Nh\xE0 cung c\u1EA5p/Ch\u1EE7 \u0110\u1ECBa \u0111i\u1EC3m l\xE0m \u0111\u1EB9p tr\xEAn Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn'
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Sau khi t\u1EA1o t\xE0i kho\u1EA3n ho\u1EB7c k\xFD h\u1EE3p \u0111\u1ED3ng v\u1EC3 qu\u1EA3ng c\xE1o \u0111\u0103ng tin th\xEC Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 s\u1EBD \u0111\u01B0\u1EE3c c\u1EA5p m\u1ED9t t\xE0i kho\u1EA3n \u0111\u1EC3 c\u1EADp nh\u1EADt th\xF4ng tin gi\u1EDBi thi\u1EC7u v\u1EC1 c\xF4ng ty/ c\xE1 nh\xE2n, s\u1EBD \u0111\u01B0\u1EE3c \u0111\u0103ng b\xE0i gi\u1EDBi thi\u1EC7u v\u1EC1 \u0111\u1ECBa \u0111i\u1EC3m c\u0169ng nh\u01B0 c\xE1c d\u1ECBch v\u1EE5 l\xE0m \u0111\u1EB9p \u0111ang kinh doanh c\u1EE7a m\xECnh tr\xEAn Lookme.vn .'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 s\u1EBD \u0111\u01B0\u1EE3c h\u1ED7 tr\u1EE3 \u0111\xE0o t\u1EA1o nh\u1EEFng k\u1EF9 n\u0103ng c\u1EA7n thi\u1EBFt \u0111\u1EC3 qu\u1EA3n l\xFD t\xE0i kho\u1EA3n ho\u1EB7c tin \u0111\u0103ng tr\xEAn Lookme.vn qua t\u1ED5ng \u0111\xE0i h\u1ED7 tr\u1EE3 ho\u1EB7c email \u0111\u1EBFn b\u1ED9 ph\u1EADn ch\u0103m s\xF3c, t\u01B0 v\u1EA5n c\u1EE7a Lookme.vn n\u1EBFu \u0111\u01B0\u1EE3c y\xEAu c\u1EA7u h\u1ED7 tr\u1EE3'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 \u0111\u01B0\u1EE3c quy\u1EC1n \u0111\u0103ng \u0111\u1ECBa \u0111i\u1EC3m d\u1ECBch v\u1EE5 l\xE0m \u0111\u1EB9p trong gian h\xE0ng c\u1EE7a m\xECnh tr\xEAn Lookme.vn ho\u1EB7c \u0111\u1EB7t banner qu\u1EA3ng c\xE1o tr\xEAn Lookme.vn v\xE0 h\u01B0\u1EDFng c\xE1c ch\xEDnh s\xE1ch \u01B0u \u0111\xE3i do ban qu\u1EA3n l\xFD Lookme.vn \u0111\u1EC1 ra trong qu\xE1 tr\xECnh ho\u1EA1t \u0111\u1ED9ng.',
          ' '
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                      'ul',
                      null,
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(
                          'i',
                          null,
                          'Tr\xE1ch nhi\u1EC7m Nh\xE0 cung c\u1EA5p/Ch\u1EE7 \u0110\u1ECBa \u0111i\u1EC3m l\xE0m \u0111\u1EB9p tr\xEAn Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn'
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 ph\u1EA3i cung c\u1EA5p \u0111\u1EA7y \u0111\u1EE7 th\xF4ng tin nh\u01B0 t\xEAn c\xF4ng ty, s\u1ED1 CMND/MST, ng\xE0nh ngh\u1EC1 l\u0129nh v\u1EF1c ho\u1EA1t \u0111\u1ED9ng, website (n\u1EBFu c\xF3),\u2026 cho ban qu\u1EA3n l\xFD Lookme.vn ',
          _react2.default.createElement(
            'b',
            null,
            '.'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 c\xF3 tr\xE1ch nhi\u1EC7m cung c\u1EA5p cho Lookme.vn b\u1EA3n sao gi\u1EA5y \u0111\u0103ng k\xFD kinh doanh. Trong tr\u01B0\u1EDDng h\u1EE3p Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 l\xE0 ch\u1EE7 s\u1EDF h\u1EEFu m\u1ED9t th\u01B0\u01A1ng hi\u1EC7u m\u1ED9t h\xE3ng ho\u1EB7c \u0111\u1EA1i l\xFD \u1EE7y quy\u1EC1n c\u1EE7a nh\xE0 \u0111\u1EA7u t\u01B0 th\xEC Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 c\xF3 tr\xE1ch nhi\u1EC7m cung c\u1EA5p m\u1ED9t (01) b\u1EA3n photo h\u1EE3p \u0111\u1ED3ng \u0111\u1EA1i l\xFD ho\u1EB7c gi\u1EA5y \u1EE6y quy\u1EC1n ph\xE2n ph\u1ED1i c\u1EE7a nh\xE0 \u0111\u1EA7u t\u01B0 \u0111\xF3.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 ph\u1EA3i cam k\u1EBFt c\xE1c th\xF4ng tin, gi\u1EA5y t\u1EDD cung c\u1EA5p l\xE0 ch\xEDnh x\xE1c v\xE0 ph\u1EA3i l\xE0 b\u1EA3n g\u1ED1c ho\u1EB7c b\u1EA3n sao y c\xF3 c\xF4ng ch\u1EE9ng c\u1EE7a ch\xEDnh quy\u1EC1n \u0111\u1ECBa ph\u01B0\u01A1ng.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 c\xF3 tr\xE1ch nhi\u1EC7m ni\xEAm y\u1EBFt ch\xEDnh x\xE1c th\xF4ng tin v\u1EC1 h\xECnh \u1EA3nh d\u1ECBch v\u1EE5, gi\xE1 c\u1EA3, ch\xEDnh s\xE1ch h\u1ED7 tr\u1EE3 (n\u1EBFu c\xF3)\u2026.m\u1ED9t c\xE1ch c\u1EE5 th\u1EC3, r\xF5 r\xE0ng.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 t\u1EA1i \u0111\xE2y cam k\u1EBFt s\u1EBD tu\xE2n th\u1EE7 to\xE0n b\u1ED9 quy \u0111\u1ECBnh c\u1EE7a \u0111\u1ECBa ph\u01B0\u01A1ng li\xEAn quan \u0111\u1EBFn vi\u1EC7c cung c\u1EA5p d\u1ECBch v\u1EE5 \u0111ang kinh doanh.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 ph\u1EA3i tu\xE2n th\u1EE7 th\u1EDDi gi\u1EDD l\xE0m vi\u1EC7c c\u1EE7a Lookme.vn , trong tr\u01B0\u1EDDng h\u1EE3p c\xF3 s\u1EF1 thay \u0111\u1ED5i v\u1EC1 l\u1ECBch l\xE0m vi\u1EC7c do c\xF3 ng\xE0y l\u1EC5 hay s\u1EF1 ki\u1EC7n \u0111\u1EB7c bi\u1EC7t, \u0111\u1ED1i t\xE1c ph\u1EA3i \u0111\u1EA3m b\u1EA3o th\xF4ng b\xE1o tr\xEAn Lookme.vn 48 gi\u1EDD tr\u01B0\u1EDBc khi th\u1EF1c hi\u1EC7n thay \u0111\u1ED5i l\u1ECBch.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'B\u1EA5t k\u1EF3 s\u1EF1 l\u1EA1m d\u1EE5ng n\xE0o c\u1EE7a Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 (nh\u01B0 c\u1ED1 \xFD kh\xF4ng th\xEAm \u0111\u01A1n h\xE0ng v\xE0o h\u1EC7 th\u1ED1ng, t\u0103ng ho\u1EB7c gi\u1EA3m ph\xED d\u1ECBch v\u1EE5 m\xE0 kh\xF4ng th\xF4ng b\xE1o cho Lookme.vn v\xE0 kh\xE1ch h\xE0ng, c\u1ED1 \xFD kh\xF4ng s\u1EED d\u1EE5ng h\u1EC7 th\u1ED1ng c\u1EE7a Lookme.vn ho\u1EB7c vi\u1EC7c \u0111\u1ED1i t\xE1c gi\u1EA3m gi\xE1 ri\xEAng cho kh\xE1ch h\xE0ng \u0111\u1EC3 kh\xE1ch h\xE0ng \u0111\u1EB7t d\u1ECBch v\u1EE5 m\xE0 kh\xF4ng th\xF4ng qua website\u2026) s\u1EBD d\u1EABn \u0111\u1EBFn vi\u1EC7c ch\u1EA5m d\u1EE9t h\u1EE3p \u0111\u1ED3ng v\xE0 \xE1p d\u1EE5ng ph\u1EA1t h\u1EE3p \u0111\u1ED3ng (c\u1ED9ng v\u1EDBi vi\u1EC7c trong tr\u01B0\u1EDDng h\u1EE3p c\xF3 c\u0103n c\u1EE9 \u0111\u1ED1i t\xE1c \u0111\xE3 gi\u1EA3m gi\xE1 ri\xEAng \u0111\u1EC3 kh\xE1ch h\xE0ng d\u1ECBch v\u1EE5 tr\xEAn website). Theo Lu\u1EADt Th\u01B0\u01A1ng M\u1EA1i Vi\u1EC7t Nam, Lookme.vn c\xF3 quy\u1EC1n y\xEAu c\u1EA7u b\u1ED3i th\u01B0\u1EDDng \u0111\u1EA7y \u0111\u1EE7 cho nh\u1EEFng t\u1ED5n th\u1EA5t v\u1EC1 hoa h\u1ED3ng m\xE0 Lookme.vn \u0111\u01B0\u1EE3c h\u01B0\u1EDFng, v\xE0 k\xE8m v\u1EDBi quy\u1EC1n y\xEAu c\u1EA7u m\u1EE9c ph\u1EA1t 8% tr\xEAn gi\xE1 tr\u1ECB vi ph\u1EA1m.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'B\u1EA5t k\u1EF3 \u0111\u01A1n h\xE0ng n\xE0o kh\xF4ng \u0111\u01B0\u1EE3c Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 th\xEAm v\xE0o h\u1EC7 th\u1ED1ng, d\u1EABn \u0111\u1EBFn xung \u0111\u1ED9t trong vi\u1EC7c \u0111\u1EB7t d\u1ECBch v\u1EE5 c\u1EE7a kh\xE1ch h\xE0ng s\u1EED d\u1EE5ng Lookme.vn , th\xEC \u0111\u1ED1i t\xE1c s\u1EBD ph\u1EA3i \u01B0u ti\xEAn ng\u01B0\u1EDDi s\u1EED d\u1EE5ng Lookme.vn .'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 ph\u1EA3i \u0111\u1EA3m b\u1EA3o s\u1ED1 l\u01B0\u1EE3ng v\xE0 ch\u1EA5t l\u01B0\u1EE3ng d\u1ECBch v\u1EE5 cam k\u1EBFt nh\u01B0 tr\xEAn website, ph\u1EA3i \u0111i\u1EC1u ch\u1EC9nh v\xE0 c\u1EA3i thi\u1EC7n theo ph\u1EA3n h\u1ED3i c\u1EE7a kh\xE1ch h\xE0ng th\xF4ng qua website, v\xE0 ch\u1ECBu to\xE0n b\u1ED9 tr\xE1ch nhi\u1EC7m li\xEAn quan \u0111\u1EBFn d\u1ECBch v\u1EE5 cung c\u1EA5p.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Vi\u1EC7c thanh to\xE1n gi\u1EEFa Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 v\xE0 Lookme.vn cho m\u1ED7i \u0111\u01A1n h\xE0ng: thanh to\xE1n d\u1ECBch v\u1EE5 th\u1EF1c hi\u1EC7n b\u1EB1ng ti\u1EC1n m\u1EB7t hay theo \u0111i\u1EC1u kho\u1EA3n \u0111\u01B0\u1EE3c c\xE1c b\xEAn th\u1ED1ng nh\u1EA5t. Lookme.vn Kh\xE1ch h\xE0ng s\u1EBD th\u1EF1c hi\u1EC7n thanh to\xE1n ph\xED \u0111\u1EB7t ch\u1ED7 cho Lookme.vn b\u1EB1ng ti\u1EC1n m\u1EB7t hay chuy\u1EC3n kho\u1EA3n ho\u1EB7c qua th\u1EBB t\xEDn d\u1EE5ng, v\xE0 Lookme.vn s\u1EBD c\u1EADp nh\u1EADt l\xEAn h\u1EC7 th\u1ED1ng v\xE0 sau \u0111\xF3 s\u1EBD th\u1EF1c hi\u1EC7n vi\u1EC7c thanh to\xE1n cho \u0111\u1ED1i t\xE1c sau khi c\u1EA5n tr\u1EEB kho\u1EA3n hoa h\u1ED3ng t\u01B0\u01A1ng \u1EE9ng cho Lookme.vn .',
          ' '
        ),
        _react2.default.createElement(
          'p',
          null,
          'Ph\u1ED1i h\u1EE3p v\u1EDBi Lookme.vn gi\u1EA3i quy\u1EBFt nh\u1EEFng v\u1EA5n \u0111\u1EC1 tranh ch\u1EA5p gi\u1EEFa th\xE0nh vi\xEAn v\u1EDBi \u0111\u1ED1i t\xE1c v\u1EC1 nh\u1EEFng khi\u1EBFu n\u1EA1i trong qu\xE1 tr\xECnh cung c\u1EA5p d\u1ECBch v\u1EE5 di\u1EC5n ra qua Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn . Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 c\xF3 ngh\u0129a v\u1EE5 ph\u1EA3i b\u1ED3i th\u01B0\u1EDDng nh\u1EEFng thi\u1EC7t h\u1EA1i c\u1EE7a th\xE0nh vi\xEAn khi l\u1ED7i \u0111\u01B0\u1EE3c x\xE1c \u0111\u1ECBnh thu\u1ED9c v\u1EC1 Nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          'XI. Quy\u1EC1n v\xE0 tr\xE1ch nhi\u1EC7m c\u1EE7a th\xE0nh vi\xEAn tham gia ho\u1EA1t \u0111\u1ED9ng tr\xEAn Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              _react2.default.createElement(
                'i',
                null,
                'Quy\u1EC1n c\u1EE7a th\xE0nh vi\xEAn'
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\xE0nh vi\xEAn s\u1EBD \u0111\u01B0\u1EE3c c\u1EA5p m\u1ED9t t\xEAn \u0111\u0103ng k\xFD v\xE0 m\u1EADt kh\u1EA9u ri\xEAng \u0111\u1EC3 \u0111\u01B0\u1EE3c v\xE0o s\u1EED d\u1EE5ng trong vi\u1EC7c qu\u1EA3n l\xFD nh\u1EEFng giao d\u1ECBch t\u1EA1i Lookme.vn th\xF4ng qua trang Lookme.vn,\u0111\u0103ng d\u1ECBch v\u1EE5 c\u1EE7a m\xECnh tr\xEAn Lookme.vn ho\u1EB7c d\xF9ng t\xEDnh n\u0103ng \u0111\u1EB7t d\u1ECBch v\u1EE5 tr\u1EF1c tuy\u1EBFn c\u1EE7a Lookme.vn ti\u1EBFn h\xE0nh \u0111\u1EB7t d\u1ECBch v\u1EE5 d\u1EF1a tr\xEAn l\u1ECBch tr\u1ED1ng c\u1EE7a c\xE1c nh\xE0 cung c\u1EA5p \u0111\u01B0\u1EE3c c\u1EADp nh\u1EADt tr\xEAn Lookme.vn.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\xE0nh vi\xEAn s\u1EBD \u0111\u01B0\u1EE3c nh\xE2n vi\xEAn c\u1EE7a Lookme.vn h\u01B0\u1EDBng d\u1EABn s\u1EED d\u1EE5ng \u0111\u01B0\u1EE3c c\xE1c c\xF4ng c\u1EE5, c\xE1c t\xEDnh n\u0103ng ph\u1EE5c v\u1EE5 cho vi\u1EC7c \u0111\u1EB7t l\u1ECBch v\xE0 s\u1EED d\u1EE5ng c\xE1c d\u1ECBch v\u1EE5 ti\u1EC7n \xEDch tr\xEAn Lookme.vn.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\xE0nh vi\xEAn c\xF3 quy\u1EC1n \u0111\xF3ng g\xF3p \xFD ki\u1EBFn cho Lookme.vn trong qu\xE1 tr\xECnh ho\u1EA1t \u0111\u1ED9ng. C\xE1c ki\u1EBFn ngh\u1ECB \u0111\u01B0\u1EE3c g\u1EEDi tr\u1EF1c ti\u1EBFp b\u1EB1ng th\u01B0, fax ho\u1EB7c email \u0111\u1EBFn cho Lookme.vn. Duy tr\xEC th\xF4ng tin li\xEAn l\u1EA1c v\u1EDBi Lookme.vn m\u1ED9t c\xE1ch k\u1ECBp th\u1EDDi v\xE0 th\xF4ng su\u1ED1t cho vi\u1EC7c v\u1EADn h\xE0nh d\u1ECBch v\u1EE5.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Nh\u1EADn h\xF3a \u0111\u01A1n GTGT do \u0111\u1ED1i t\xE1c c\u1EE7a Lookme.vn xu\u1EA5t khi thanh to\xE1n \u0111\u1EA7y \u0111\u1EE7 ph\xED d\u1ECBch v\u1EE5 \u0111\xE3 \u0111\u1EB7t th\xF4ng qua Lookme.vn.'
        ),
        _react2.default.createElement(
          'p',
          null,
          '\u0110\u1ED1i t\xE1c c\xF3 quy\u1EC1n t\u1EEB ch\u1ED1i kh\xE1ch h\xE0ng v\xE0 ch\u1EB7n quy\u1EC1n \u0111\u1EB7t l\u1ECBch (sau khi \u0111\u1EB7t l\u1EA7n \u0111\u1EA7u) v\u1EDBi \u0111i\u1EC1u ki\u1EC7n c\xF3 l\xFD do h\u1EE3p l\xFD k\xE8m theo v\u0103n b\u1EA3n gi\u1EA3i th\xEDch cho vi\u1EC7c t\u1EEB ch\u1ED1i \u0111\xF3. S\u1EF1 t\u1EEB ch\u1ED1i n\xE0y s\u1EBD \u0111\u01B0\u1EE3c trao \u0111\u1ED5i v\u1EDBi Lookme.vn n\u1EBFu c\xF3 y\xEAu c\u1EA7u t\u1EEB Lookme.vn.'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              _react2.default.createElement(
                'i',
                null,
                'Tr\xE1ch nhi\u1EC7m th\xE0nh vi\xEAn'
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\xE0nh vi\xEAn s\u1EBD t\u1EF1 ch\u1ECBu tr\xE1ch nhi\u1EC7m v\u1EC1 b\u1EA3o m\u1EADt v\xE0 l\u01B0u gi\u1EEF v\xE0 m\u1ECDi ho\u1EA1t \u0111\u1ED9ng s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 d\u01B0\u1EDBi t\xEAn \u0111\u0103ng k\xFD, m\u1EADt kh\u1EA9u v\xE0 h\u1ED9p th\u01B0 \u0111i\u1EC7n t\u1EED c\u1EE7a m\xECnh.',
          ' '
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\xE0nh vi\xEAn c\xF3 tr\xE1ch nhi\u1EC7m th\xF4ng b\xE1o k\u1ECBp th\u1EDDi cho Lookme.vn v\u1EC1 nh\u1EEFng h\xE0nh vi s\u1EED d\u1EE5ng tr\xE1i ph\xE9p, l\u1EA1m d\u1EE5ng, vi ph\u1EA1m b\u1EA3o m\u1EADt, l\u01B0u gi\u1EEF t\xEAn \u0111\u0103ng k\xFD v\xE0 m\u1EADt kh\u1EA9u c\u1EE7a m\xECnh \u0111\u1EC3 hai b\xEAn c\xF9ng h\u1EE3p t\xE1c x\u1EED l\xFD. Trong tr\u01B0\u1EDDng h\u1EE3p th\xF4ng tin li\xEAn l\u1EA1c ho\u1EB7c h\u1EE3p t\xE1c v\u1EDBi \u0111\u1ED1i t\xE1c kh\xF4ng \u0111\u01B0\u1EE3c \u0111\xE1p \u1EE9ng m\u1ED9t c\xE1ch ph\xF9 h\u1EE3p, th\xEC Lookme.vn kh\xF4ng c\xF3 tr\xE1ch nhi\u1EC7m v\u1EC1 b\u1EA5t c\u1EE9 khi\u1EBFu n\u1EA1i v\u1EC1 thi\u1EC7t h\u1EA1i n\xE0o x\u1EA3y ra.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\xE0nh vi\xEAn cam k\u1EBFt nh\u1EEFng th\xF4ng tin cung c\u1EA5p cho Lookme.vn v\xE0 nh\u1EEFng th\xF4ng tin \u0111ang t\u1EA3i l\xEAn Lookme.vn l\xE0 ch\xEDnh x\xE1c.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\xE0nh vi\xEAn cam k\u1EBFt, \u0111\u1ED3ng \xFD kh\xF4ng s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 c\u1EE7a Lookme.vn v\xE0o nh\u1EEFng m\u1EE5c \u0111\xEDch b\u1EA5t h\u1EE3p ph\xE1p, kh\xF4ng h\u1EE3p l\xFD, l\u1EEBa \u0111\u1EA3o, \u0111e do\u1EA1, th\u0103m d\xF2 th\xF4ng tin b\u1EA5t h\u1EE3p ph\xE1p, ph\xE1 ho\u1EA1i, t\u1EA1o ra v\xE0 ph\xE1t t\xE1n virus g\xE2y h\u01B0 h\u1EA1i t\u1EDBi h\u1EC7 th\u1ED1ng, c\u1EA5u h\xECnh, truy\u1EC1n t\u1EA3i th\xF4ng tin c\u1EE7a Lookme.vn hay s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 c\u1EE7a m\xECnh v\xE0o m\u1EE5c \u0111\xEDch \u0111\u1EA7u c\u01A1, l\u0169ng \u0111o\u1EA1n th\u1ECB tr\u01B0\u1EDDng t\u1EA1o nh\u1EEFng \u0111\u01A1n \u0111\u1EB7t h\xE0ng, ch\xE0o h\xE0ng gi\u1EA3, k\u1EC3 c\u1EA3 ph\u1EE5c v\u1EE5 cho vi\u1EC7c ph\xE1n \u0111o\xE1n nhu c\u1EA7u th\u1ECB tr\u01B0\u1EDDng. Trong tr\u01B0\u1EDDng h\u1EE3p vi ph\u1EA1m th\xEC th\xE0nh vi\xEAn ph\u1EA3i ch\u1ECBu tr\xE1ch nhi\u1EC7m v\u1EC1 c\xE1c h\xE0nh vi c\u1EE7a m\xECnh tr\u01B0\u1EDBc ph\xE1p lu\u1EADt.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\xE0nh vi\xEAn cam k\u1EBFt kh\xF4ng \u0111\u01B0\u1EE3c thay \u0111\u1ED5i, ch\u1EC9nh s\u1EEDa, sao ch\xE9p, truy\u1EC1n b\xE1, ph\xE2n ph\u1ED1i, cung c\u1EA5p v\xE0 t\u1EA1o nh\u1EEFng c\xF4ng c\u1EE5 t\u01B0\u01A1ng t\u1EF1 c\u1EE7a d\u1ECBch v\u1EE5 do Lookme.vn cung c\u1EA5p cho m\u1ED9t b\xEAn th\u1EE9 ba n\u1EBFu kh\xF4ng \u0111\u01B0\u1EE3c s\u1EF1 \u0111\u1ED3ng \xFD c\u1EE7a Lookme.vn trong Quy \u0111\u1ECBnh n\xE0y.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\xE0nh vi\xEAn kh\xF4ng \u0111\u01B0\u1EE3c h\xE0nh \u0111\u1ED9ng g\xE2y m\u1EA5t uy t\xEDn c\u1EE7a Lookme.vn d\u01B0\u1EDBi m\u1ECDi h\xECnh th\u1EE9c nh\u01B0 g\xE2y m\u1EA5t \u0111o\xE0n k\u1EBFt gi\u1EEFa c\xE1c th\xE0nh vi\xEAn b\u1EB1ng c\xE1ch s\u1EED d\u1EE5ng t\xEAn \u0111\u0103ng k\xFD th\u1EE9 hai, th\xF4ng qua m\u1ED9t b\xEAn th\u1EE9 ba ho\u1EB7c tuy\xEAn truy\u1EC1n, ph\u1ED5 bi\u1EBFn nh\u1EEFng th\xF4ng tin kh\xF4ng c\xF3 l\u1EE3i cho uy t\xEDn c\u1EE7a Lookme.vn.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Tu\xE2n th\u1EE7 nghi\xEAm t\xFAc v\xE0 cam k\u1EBFt ngh\u0129a v\u1EE5 thanh to\xE1n v\xE0 c\xE1c ngh\u0129a v\u1EE5 kh\xE1c theo h\u1EE3p \u0111\u1ED3ng.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Tu\xE2n th\u1EE7 h\u1EE3p \u0111\u1ED3ng v\xE0 c\u1EA5p \u0111\u1ED9c quy\u1EC1n cung c\u1EA5p d\u1ECBch v\u1EE5 \u0111\u1ED1i v\u1EDBi website. \u0110\u1ED1i t\xE1c cam k\u1EBFt kh\xF4ng s\u1EED d\u1EE5ng h\u1EC7 th\u1ED1ng/gi\u1EA3i ph\xE1p/trang web/\u1EE9ng d\u1EE5ng/ph\u1EA7n m\u1EC1m kh\xE1c c\xF3 th\u1EC3 g\xE2y xung \u0111\u1ED9t l\u1EE3i \xEDch tr\u1EF1c ti\u1EBFp \u0111\u1EBFn d\u1ECBch v\u1EE5.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'XII. \u0110i\u1EC1u kho\u1EA3n \xE1p d\u1EE5ng'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn c\xF3 quy\u1EC1n v\xE0 c\xF3 th\u1EC3 thay \u0111\u1ED5i Quy ch\u1EBF n\xE0y b\u1EB1ng c\xE1ch th\xF4ng b\xE1o l\xEAn Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn cho c\xE1c \u0110\u1ED1i t\xE1c v\xE0 th\xE0nh vi\xEAn bi\u1EBFt. Vi\u1EC7c th\xE0nh vi\xEAn ti\u1EBFp t\u1EE5c s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5 sau khi quy ch\u1EBF s\u1EEDa \u0111\u1ED5i \u0111\u01B0\u1EE3c c\xF4ng b\u1ED1 v\xE0 th\u1EF1c thi \u0111\u1ED3ng ngh\u0129a v\u1EDBi vi\u1EC7c th\xE0nh vi\xEAn \u0111\xE3 ch\u1EA5p nh\u1EADn Quy ch\u1EBF s\u1EEDa \u0111\u1ED5i n\xE0y.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Quy ch\u1EBF ho\u1EA1t \u0111\u1ED9ng s\u1EBD \u0111\u01B0\u1EE3c Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Lookme.vn c\u1EADp nh\u1EADt b\u1ED5 sung li\xEAn t\u1EE5c v\xE0 th\xF4ng b\xE1o tr\u01B0\u1EDBc khi th\u1EF1c hi\u1EC7n/ c\xF3 hi\u1EC7u l\u1EF1c thi h\xE0nh l\xE0 5 ng\xE0y l\xE0m vi\u1EC7c. \u0110\u1ED1i t\xE1c v\xE0 th\xE0nh vi\xEAn tham gia Website cung c\u1EA5p d\u1ECBch v\u1EE5 TM\u0110T Fivigo.com.vn c\xF3 tr\xE1ch nhi\u1EC7m tu\xE2n theo quy ch\u1EBF hi\u1EC7n h\xE0nh khi giao d\u1ECBch tr\xEAn website Lookme.vn.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'XIII. \u0110i\u1EC1u kho\u1EA3n cam k\u1EBFt'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'M\u1ECDi th\xE0nh vi\xEAn v\xE0 \u0111\u1ED1i t\xE1c/',
          _react2.default.createElement(
            'b',
            null,
            'Nh\xE0 cung c\u1EA5p'
          ),
          ' h\xE0ng khi s\u1EED d\u1EE5ng Lookme.vn l\xE0m giao d\u1ECBch mua b\xE1n tr\u1EF1c tuy\u1EBFn th\xEC \u0111\u1ED3ng ngh\u0129a vi\u1EC7c c\xE1c b\xEAn c\xF3 li\xEAn quan \u0111\xE3 ch\u1EA5p thu\u1EADn tu\xE2n theo quy ch\u1EBF n\xE0y.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'M\u1ECDi th\u1EAFc m\u1EAFc c\u1EE7a kh\xE1ch h\xE0ng xin vui l\xF2ng li\xEAn h\u1EC7 v\u1EDBi Lookme.vn theo th\xF4ng tin d\u01B0\u1EDBi \u0111\xE2y \u0111\u1EC3 \u0111\u01B0\u1EE3c gi\u1EA3i \u0111\xE1p:'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              'S\xE0n giao d\u1ECBch/Website Th\u01B0\u01A1ng m\u1EA1i \u0111i\u1EC7n t\u1EED : '
            ),
            'http://www.Lookme.vn/'
          ),
          _react2.default.createElement(
            'li',
            null,
            'C\xF4ng ty/T\u1ED5 ch\u1EE9c : C\xF4ng ty C\u1ED5 Ph\u1EA7n Lookme'
          ),
          _react2.default.createElement(
            'li',
            null,
            'V\u0103n ph\xF2ng giao d\u1ECBch: 481/14 \u0110\u01B0\u1EDDng s\u1ED1 10, Ph\u01B0\u1EDDng 8, Qu\u1EADn G\xF2 V\u1EA5p, Th\xE0nh ph\u1ED1 H\u1ED3 Ch\xED Minh'
          ),
          _react2.default.createElement(
            'li',
            null,
            'Tel: 0933207298'
          ),
          _react2.default.createElement(
            'li',
            null,
            'Email: hr@lookme.vn '
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'table',
          { cellSpacing: '0', cellPadding: '0', className: styles.headerTable },
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                { valign: 'middle' },
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement('br', null)
                )
              ),
              _react2.default.createElement(
                'td',
                { valign: 'middle' },
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    ' \u0110\u1EA0I \u0110I\u1EC6N C\xD4NG TY'
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    'Gi\xE1m \u0110\u1ED1c '
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement('br', null)
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement('br', null)
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    'NGUY\u1EC4N TH\u1ECA KIM OANH'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                { valign: 'middle' },
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement('br', null)
                )
              ),
              _react2.default.createElement(
                'td',
                { valign: 'middle' },
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement('br', null)
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement('br', null)
        )
      );
    }
  }]);
  return Activity;
}(_react.Component);

exports.default = Activity;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Policy/Activity.js
// module id = 1648
// module chunks = 0